//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const moment = require("moment-timezone");
import api from "@/services/api";
import {
  server,
  imagemasterTMUrl,
  filemasterTMUrl,
} from "@/services/constants";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import pdfvuer from "pdfvuer";
export default {
  name: "About",
  data(vm) {
    return {
      sendBilling: "Reply All",
      sendBillingList: ["Reply All", "Specific Email", "Link"],
      sendBillingDetail: "",
      indexdeleteattreciept: -1,
      dialogconfirmdeleteattrecipt: false,
      customer_list: [],
      customer_selected: null,
      customer_address: "",

      disablebtnappointmenttimeline: false,
      disStatusSave: false,
      disableCalculateNewRenewalDate: false,
      country_list: [],
      date_of_public: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date_of_opposition: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date_of_filling_appeal: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date_of_filling_lawsuit: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date_of_renewal: null,
      date_of_renewal_filed: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      next_deadline: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      dateof_filling_affidavits: null,
      endorsed_start: null,
      endorsed_end: null,
      date_of_regis: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date_of_application: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date_of_closed: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date_of_issuing_certificate: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      menudate_of_issuing_certificate: false,
      menudate_of_closed: false,
      dialogpreviewimage: false,
      checkfileapreview: false,
      previewpopupfile: [],
      previewpopupfile2: [],
      dialogpreviewfile: false,
      dialogDelete: false,
      dialogDeleteimage: false,
      fileindex: -1,
      preview_list2: [],
      getpreview_list: [],
      image: null,
      previewimage: null,
      previewimageedit: null,
      image_list: [],
      preview_list: [],
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      tmstatus_list: [],
      contact_owner_list: [],
      contact_agent_list: [],
      contact_associate_list: [],
      objecttype_list: [],
      filename: [],
      imagename: "",
      load_bg: false,
      checkfileadd: false,
      checkimageadd: false,
      page: 1,
      numPages: 0,
      numPagespreview: 0,
      pdfdata: undefined,
      errors: [],
      scale: "page-width",
      date_of_infringement: null,
      showaddItem: {
        agency: "",
        date_of_infringement: null,
        ref_search: 0,
        tm_type: 0,
        class_no: "",
        country: "",
        cliant_ref: "",
        name_of_client: "",
        file_no: "",
        regis_no: "",
        trademark: "",
        owner_contact: "",
        owner_address: "",
        agent_contact: 0,
        agent_address: "",
        agent_email: "",
        associate_contact: 0,
        associate_address: "",
        app_no: "",
        good_service: "",
        condition_of_regis: "",
        val_no: "",
        page_no: "",
        tmstatusasoff: 0,
        dip_link: "",
        remark: "",
        date_of_public: "",
        date_of_opposition: "",
        date_of_filling_appeal: "",
        date_of_filling_lawsuit: "",
        date_of_regis: "",
        date_of_application: "",
        date_of_renewal: "",
        date_of_renewal_filed: "",
        date_of_filling: "",
        next_deadline: "",
        endorsed_start: "",
        dateof_filling_affidavits: "",
        endorsed_end: "",
        closed: false,
        disclaim: "",
        date_of_closed: "",
        date_of_issuing_certificate: "",
        user_create: localStorage.getItem(server.USER_ID),
        receive_date: null,
        filling_date: null,
        enddate: null,
        internaldate: null,
      },
      menuaddappdate: false,
      menupublication: false,
      menuopposition: false,
      menufilling_appeal: false,
      menufilling_lawsuit: false,
      menurenewal: false,
      menurenewal_filed: false,
      menuaffidavits: false,
      menufiling_affidavits: false,
      menufiling_endorsed_start: false,
      menufiling_endorsed_end: false,
      menuadd: false,
      fullPage: true,
      datefrom: vm.formatDate(new Date().toISOString().substr(0, 10)),
      dateto: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      search: "",
      mDataArray: [],
      sostatus: false,
      owner_contact_list: [],
      showFiling: false,
      showIsSearch: false,
      showTrademarkOhter: false,
      showTrademarkInfringementPoliceCustoms: false,
      priorityList: [
        {
          id: 0,
          number: "",
          date: "",
          country: "",
          menu: false,
        },
      ],
      priorityListOld: [],
      images: [],
      previews: [],
      imagenames: [],
      indexDelImage: -1,
      carouselIndex: 0,

      //cer
      preview_list_cer: [], // เก็บ task ของ PDF preview
      image_list_cer: [], // เก็บไฟล์ PDF/รูป
      filename_cer: [], // ชื่อไฟล์
      getpreview_list_cer: [], // เก็บ base64 ของไฟล์ PDF/รูป
      preview_list2_cer: [], // สำรอง preview list
      checkfileeadd_cer: false, // ใช้ตรวจสอบว่ามีไฟล์อัพโหลดหรือไม่
      checkfileadd_cer: false, // ใช้ตรวจสอบว่า PDF preview โหลดเสร็จหรือยัง
      numPages_cer: 0, // จำนวนหน้า PDF
      page_cer: 1,
      fileindex_cer: -1,
      dialogDelete_cer: false,

      filling_date: null,
      receive_date: null,
      enddate: null,
      internaldate: null,
      menuReceive: false,
      menuFilling: false,
      menuStart: false,
      menuDeadline: false,
      fileList_search: [],
      fileList_submitted: [],
      fileList_notice: [],
      fileList_receipt: [],
      fileList_good_service: [],
      fileList_decision: [],
      selectedOption: null,
      Agency_list: [
        "กรมสอบสวนคดีพิเศษ (DSI.)",
        "ศูนย์ปราบปรามการละเมิดทรัพย์สินทางปัญญา (ศปลป.ตร.) สำนักงานตำรวจแห่งชาติ",
        "กองบังคับการปราบปรามการกระทำความผิดเกี่ยวกับอาชญากรรมทางเศรษฐกิจ (ปอศ) สำนักงานตำรวจแห่งชาติ",
        "กรมศุลกากร",
      ],
      dataFileAll: [],
      getpreview_listnotice: [],
      preview_listnotice: [],
      preview_listnotice2: [],
      image_listnotice: [],
      filenamenotice: [],
      checkfilenotice: false,
      dialogconfirmdeletenoticefile: false,
      indexdeleteattachfilelist: -1,
      dialogconfirmdeleteattachfile: false,
      indexdeleteattachfile: -1,
      getpreview_listattach: [],
      preview_listattach: [],
      preview_listattach2: [],
      image_listattach: [],
      filenameattach: [],
      checkfileattach: false,
      old_tm_type: 0,
      removeNoticFile: [],
      removeAttactFile: [],
      removeTMimageFile: [],
      removeTMimageOppFile: [],
      old_file_no: "",
      old_app_no: "",

      imagesOpposed: [],
      previewsOpposed: [],
      imagenamesOpposed: [],
      checkimageaddOpposed: false,
      dialogDeleteimageOpposed: false,
      indexDelImageOpposed: -1,

      decisionBoxes: [
        {
          id: 0,
          files: [],
          date: "",
          level: 1,
          menuReceiveBox: false,
          result: "",
        },
      ],
      labels: [
        // "อัปโหลดไฟล์คำวินิจฉัยของนายทะเบียน",
        // "อัปโหลดไฟล์คำวินิจฉัยของชั้นคณะกรรมการ",
        // "อัปโหลดไฟล์คำวินิจฉัยไปศาล",
      ],
      labelsDecripnt: [
        // "วันที่รับคำวินิจฉัยของนายทะเบียน",
        // "วันที่รับคำวินิจฉัยของชั้นคณะกรรมการ",
        // "วันที่รับคำวินิจฉัยไปศาล",
      ],
      indexLengthBox: 0,
      removeBoxFile: [],
      carouselIndexOpposed: 0,
      removeFillingFile: [],
      removeFillingCer: [],
      ref_search_list: [],
      showtimelineData: [],
      getpreview_listreceipt: [],
      preview_listrecicpt: [],
      preview_listrecipt2: [],
      image_listrecicpt: [],
      filenamerecive: [],
      removeReciveFile: [],
      oldGoodsService: {
        name: "",
        type: "",
        id: 0,
      },
    };
  },
  components: {
    SuccessDialog,
    SuccessDialogPush,
    pdf: pdfvuer,
  },
  async mounted() {
    await this.loadCustomerComboboxMetter();
    await this.loadfilenoSearch();
    await this.loaddataobjecttypeBygroupId();
    await this.loaddatacontactByContact_type_owner();
    await this.loaddatacontactByContact_type_agent();
    await this.loaddatacontactByContact_type_associate();
    await this.loaddatacountry();
    await this.loaddatatmupdatestatus();
    await this.loaddataedit();
    await this.loadfiledata();
    await this.loadDataBox();
    await this.loaddataPriority();
    await this.loadshowTimeline();
    this.$hideLoader();
  },

  watch: {
    show: function (s) {
      if (s) {
        this.getPdf();
      }
    },
    page: function (p) {
      if (
        window.pageYOffset <= this.findPos(document.getElementById(p)) ||
        (document.getElementById(p + 1) &&
          window.pageYOffset >= this.findPos(document.getElementById(p + 1)))
      ) {
        // window.scrollTo(0,this.findPos(document.getElementById(p)));
        document.getElementById(p).scrollIntoView();
      }
    },
    date_of_regis(val) {
      this.showaddItem.date_of_regis = this.formatDate(this.date_of_regis);
    },
    date_of_application(val) {
      this.showaddItem.date_of_application = this.formatDate(
        this.date_of_application
      );
    },
    date_of_public(val) {
      this.showaddItem.date_of_public = this.formatDate(this.date_of_public);
    },
    date_of_opposition(val) {
      this.showaddItem.date_of_opposition = this.formatDate(
        this.date_of_opposition
      );
    },
    date_of_filling_appeal(val) {
      this.showaddItem.date_of_filling_appeal = this.formatDate(
        this.date_of_filling_appeal
      );
    },
    date_of_filling_lawsuit(val) {
      this.showaddItem.date_of_filling_lawsuit = this.formatDate(
        this.date_of_filling_lawsuit
      );
    },
    date_of_renewal(val) {
      this.showaddItem.date_of_renewal = this.formatDate(this.date_of_renewal);
    },
    date_of_renewal_filed(val) {
      this.showaddItem.date_of_renewal_filed = this.formatDate(
        this.date_of_renewal_filed
      );
    },

    next_deadline(val) {
      this.showaddItem.next_deadline = this.formatDate(this.next_deadline);
    },
    dateof_filling_affidavits(val) {
      this.showaddItem.dateof_filling_affidavits = this.formatDate(
        this.dateof_filling_affidavits
      );
    },
    endorsed_start(val) {
      this.showaddItem.endorsed_start = this.formatDate(this.endorsed_start);
    },
    endorsed_end(val) {
      this.showaddItem.endorsed_end = this.formatDate(this.endorsed_end);
    },
    date_of_closed(val) {
      this.showaddItem.date_of_closed = this.formatDate(this.date_of_closed);
    },
    date_of_issuing_certificate(val) {
      this.showaddItem.date_of_issuing_certificate = this.formatDate(
        this.date_of_issuing_certificate
      );
    },
    receive_date(val) {
      this.showaddItem.receive_date = this.formatDate(this.receive_date);
    },
    filling_date(val) {
      this.showaddItem.filling_date = this.formatDate(this.filling_date);
    },
    startdate(val) {
      this.showaddItem.startdate = this.formatDate(this.startdate);
    },
    enddate(val) {
      this.showaddItem.enddate = this.formatDate(this.enddate);
    },
    internaldate(val) {
      this.showaddItem.internaldate = this.formatDate(this.internaldate);
    },
    date_of_infringement(val) {
      this.showaddItem.date_of_infringement = this.formatDate(
        this.date_of_infringement
      );
    },
  },
  methods: {
    //onChanege customer filter full_address by id
    async onSelectComboboxMetterChange(value) {
      // console.log(`onSelectComboboxMetterChange: ${value}`);
      // console.log(`customer_list:${JSON.stringify(this.customer_list)}`);

      const selectedCustomer = this.customer_list.find(
        (customer) => customer.id === value
      );
      this.customer_address = selectedCustomer
        ? selectedCustomer.full_address
        : "";
    },
    async loadCustomerComboboxMetter() {
      const result = await api.getCustomerComboboxByMetter(
        localStorage.getItem(server.COMPANYID)
      );
      // console.log(`loadCustomerComboboxMetter: ${JSON.stringify(result.data)}`);

      this.customer_list = result.data;
    },

    editItemtimeline(item) {
      const url = `/appointmenttm-edit/${item.appointment_id}`; // หรือใส่ query ?file_no=xxx
      window.open(url, "_blank"); // เปิดหน้าใหม่
    },
    async loadshowTimeline() {
      this.showtimelineData = [];
      // this.$showLoader();

      var resTimeline = await api.gettimelinemastertm({
        file_no: this.showaddItem.file_no,
      });
      // var datalist = [];
      // if (resTimeline.data && resTimeline.data.length > 0) {
      //   for (const [index, item] of resTimeline.data.entries()) {
      //     if (Number(item.doctype == 7)) {
      //       item.show_date = `Application Date - ${item.receive_date}`;
      //       item.sort_date = item.receive_date;
      //     } else if (
      //       [
      //         1, 2, 4, 5, 6, 8, 9, 10, 19, 104, 105, 108, 109, 110, 111, 112,
      //         113, 701, 702, 801, 802, 1002, 1003, 1004, 1005, 1006, 1007, 1009,
      //         1010, 1011,
      //       ].includes(Number(item.doctype))
      //     ) {
      //       item.show_date = `Submitted Date - ${item.filling_date}`;
      //       item.sort_date = item.filling_date;
      //     } else if (Number(item.doctype == 3)) {
      //       item.show_date = `Renewal Filed Date - ${item.receive_date}`;
      //       item.sort_date = item.receive_date;
      //     }

      //     datalist.push(item);
      //   }

      //   const sortedData = datalist.sort((a, b) => {
      //     // ถ้า a ไม่มี sort_date → ไปหลังสุด
      //     if (!a.sort_date && b.sort_date) return 1;
      //     // ถ้า b ไม่มี sort_date → ไปหลังสุด
      //     if (a.sort_date && !b.sort_date) return -1;
      //     // ถ้าทั้งคู่ไม่มี sort_date → เท่ากัน
      //     if (!a.sort_date && !b.sort_date) return 0;

      //     // แยกวันที่
      //     const partsA = a.sort_date.split("/");
      //     const partsB = b.sort_date.split("/");

      //     // ถ้า format ไม่ครบ → ไปหลังสุด
      //     if (partsA.length !== 3 || partsB.length !== 3) return 0;

      //     const [dayA, monthA, yearA] = partsA.map(Number);
      //     const [dayB, monthB, yearB] = partsB.map(Number);

      //     const dateA = new Date(yearA, monthA - 1, dayA);
      //     const dateB = new Date(yearB, monthB - 1, dayB);

      //     return dateB - dateA; // เรียงจากใหม่ → เก่า
      //   });

      //   this.showtimelineData = sortedData;
      // }

      // this.$hideLoader();
    },
    async loadfilenoSearch() {
      var resFileNoSearch = await api.gteTMFileNoSearch();
      if (resFileNoSearch.data.length > 0) {
        this.ref_search_list = resFileNoSearch.data;
      }
    },
    removeFileBox(boxIndex, fileIndex) {
      if (this.decisionBoxes[boxIndex].files[fileIndex].isOld) {
        this.removeBoxFile.push({
          id: this.decisionBoxes[boxIndex].files[fileIndex].id,
          name: this.decisionBoxes[boxIndex].files[fileIndex].name,
          type: "file",
          masterId: Number(this.$route.params.mastertm_id),
        });
      }
      this.decisionBoxes[boxIndex].files.splice(fileIndex, 1);
    },
    async previewBoxfile(index, fIndex) {
      var dataBoxFile = this.decisionBoxes[index].files[fIndex];
      if (dataBoxFile.isOld) {
        let fileUrl = `${filemasterTMUrl}/${this.$route.params.mastertm_id}/${dataBoxFile.name}`;
        const newTab = window.open("");
        newTab.document.write(`
            <html>
              <head>
                <title>PDF Preview</title>
                <style>
                  html, body { margin:0; height:100%; overflow:hidden; }
                  iframe { border:none; width:100%; height:100%; }
                </style>
              </head>
              <body>
                <iframe src="${fileUrl}" title="PDF Preview"></iframe>
              </body>
            </html>
          `);
        newTab.document.close();
      } else {
        const reader = new FileReader();
        reader.onload = (e) => {
          const fileData = e.target.result;
          let pdf_newTab = window.open("");
          pdf_newTab.document.write(`
            <html>
              <head>
                <title>PDF Preview</title>
                <style>
                  html, body {
                    margin: 0;
                    height: 100%;
                    overflow: hidden;
                  }
                  iframe {
                    border: none;
                    width: 100%;
                    height: 100%;
                  }
                </style>
              </head>
              <body>
                <iframe src="${fileData}" title="PDF Preview"></iframe>
              </body>
            </html>
          `);
          pdf_newTab.document.close();
        };
        // ตรงนี้ต้องใช้ dataBoxFile ไม่ใช่ checkfile
        reader.readAsDataURL(dataBoxFile);
      }
    },
    async popupdeleteimageOpposed(index) {
      this.indexDelImageOpposed = index;
      this.dialogDeleteimageOpposed = true;
    },
    async closeDeleteimageOpposed() {
      this.dialogDeleteimageOpposed = false;
    },
    async deleteItemConfirmimageOpposed() {
      let dataDel = this.imagesOpposed[this.indexDelImageOpposed];
      if (dataDel.isOld) {
        this.removeTMimageOppFile.push(dataDel);
      }
      this.imagesOpposed.splice(this.indexDelImageOpposed, 1);
      this.imagenamesOpposed.splice(this.indexDelImageOpposed, 1);
      this.previewsOpposed.splice(this.indexDelImageOpposed, 1);
      this.dialogDeleteimageOpposed = false;
    },
    triggerUpload(index) {
      // ใช้ refs แบบ array
      const input = this.$refs.fileInputs[index];
      if (input) input.click();
    },
    formatDateToDMY(date) {
      if (!date) return "";
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    },
    addBox(index) {
      this.decisionBoxes.push({
        id: 0,
        files: [],
        date: "",
        menuReceiveBox: false,
        result: "",
        level: index + 2,
      });
    },
    removeBox(index) {
      this.decisionBoxes.splice(index, 1);
    },
    onFilesSelected(index, event) {
      const input = event.target;
      if (!input || !input.files || input.files.length === 0) return;

      const rawFiles = Array.from(input.files);

      // ให้แน่ใจว่า decisionBoxes[index].files และ .previews มีอยู่ (reactive)
      if (!this.decisionBoxes[index]) {
        console.warn("no decisionBoxes entry for index", index);
        return;
      }
      if (!this.decisionBoxes[index].files) {
        this.$set(this.decisionBoxes[index], "files", []);
      }
      if (!this.decisionBoxes[index].previews) {
        this.$set(this.decisionBoxes[index], "previews", []);
      }

      for (const rawFile of rawFiles) {
        // เฉพาะ PDF เท่านั้น (เช็กทั้ง mime type และนามสกุล)
        const isPdf =
          rawFile.type === "application/pdf" ||
          rawFile.name.toLowerCase().endsWith(".pdf");
        if (!isPdf) {
          console.warn("skip non-pdf file:", rawFile.name);
          continue;
        }

        // ใช้ฟังก์ชันของคุณในการ sanitize + กันชื่อซ้ำ
        // getUniqueFileName(file) ตามที่คุณมี จะคืนเป็น File ใหม่ และ push ชื่อเข้า this.dataFileAll
        const file =
          typeof this.getUniqueFileName === "function"
            ? this.getUniqueFileName(rawFile)
            : new File([rawFile], rawFile.name, { type: rawFile.type }); // fallback

        // เก็บไฟล์ลงใน box
        this.decisionBoxes[index].files.push(file);

        // สร้าง preview (ถ้าต้องการแสดง thumbnail / viewer)
        const reader = new FileReader();
        reader.onload = (e) => {
          this.decisionBoxes[index].previews.push(e.target.result);
        };
        reader.readAsDataURL(file);
      }

      // รีเซ็ต input เพื่อเปิดให้เลือกไฟล์เดิมได้อีกครั้ง
      input.value = "";
    },
    selectOwner(id) {
      const idList = id.split(",").map((x) => x.trim());

      const foundList = this.contact_owner_list.filter((item) =>
        idList.includes(String(item.contact_id))
      );

      this.owner_contact_list = foundList;

      this.onSelectOwnerChange();
    },
    async loaddataedit() {
      var resDataList = await api.getMasterTMById(
        this.$route.params.mastertm_id
      );
      console.log(resDataList)


      if (resDataList.data.length > 0) {
        var dataset = resDataList.data[0];
        this.sendBilling = dataset.send_billing;
        this.sendBillingDetail = dataset.send_billing_detail;
        this.showaddItem.tm_type = dataset.tm_type;
        this.old_tm_type = dataset.tm_type;
        this.showaddItem.country = dataset.country;
        this.showaddItem.file_no = (dataset.file_no || "").trim().toUpperCase();
        this.old_file_no = dataset.file_no;
        this.showaddItem.trademark = dataset.trademark;
        this.showaddItem.cliant_ref = dataset.cliant_ref;
        this.showaddItem.class_no = dataset.class_no;
        this.showaddItem.tmstatusasoff = dataset.tmstatusasoff;
        if (Number(dataset.tmstatusasoff == 6)) {
          this.disStatusSave = true;
        }
        this.showaddItem.remark = dataset.remark;

        this.showaddItem.name_of_client = dataset.name_of_client;
        this.showaddItem.owner_contact = dataset.owner_contact;
        this.selectOwner(dataset.owner_contact);
        this.customer_selected = dataset.cus_billing_id;
        await this.onSelectComboboxMetterChange(this.customer_selected);

        if (
          dataset.agent_contact &&
          dataset.agent_contact != 0 &&
          dataset.agent_contact != ""
        ) {
          this.showaddItem.agent_contact = dataset.agent_contact;
          this.onSelectAgentChange(this.showaddItem.agent_contact);
        } else {
          this.showaddItem.agent_contact = 0;
        }
        if (
          dataset.associate_contact &&
          dataset.associate_contact != 0 &&
          dataset.associate_contact != ""
        ) {
          this.showaddItem.associate_contact = dataset.associate_contact;
          this.onSelectAssociateChange(this.showaddItem.associate_contact);
        } else {
          this.showaddItem.associate_contact = 0;
        }
        if (this.showaddItem.tm_type == 1 || this.showaddItem.tm_type == 3) {
          this.showFiling = true;
          this.showaddItem.app_no = dataset.app_no;
          this.showaddItem.ir_no = dataset.ir_no;
          this.old_app_no = dataset.app_no;
          this.showaddItem.date_of_application = this.formatDate(
            dataset.date_of_application
          );
          this.date_of_application = dataset.date_of_application;
          this.showaddItem.date_of_public = this.formatDate(
            dataset.date_of_public
          );
          this.date_of_public = dataset.date_of_public;
          this.showaddItem.regis_no = dataset.regis_no;
          this.showaddItem.date_of_regis = this.formatDate(
            dataset.date_of_regis
          );
          this.date_of_regis = dataset.date_of_regis;
          this.showaddItem.date_of_issuing_certificate = this.formatDate(
            dataset.date_of_issuing_certificate
          );
          this.date_of_issuing_certificate =
            dataset.date_of_issuing_certificate;
          this.showaddItem.date_of_renewal_filed = this.formatDate(
            dataset.date_of_renewal_filed
          );
          this.date_of_renewal_filed = dataset.date_of_renewal_filed;
          this.showaddItem.date_of_renewal = this.formatDate(
            dataset.date_of_renewal
          );
          this.date_of_renewal = dataset.date_of_renewal;
          this.showaddItem.good_service = (dataset.good_service || "").replace(
            /<br\s*\/?>/gi,
            "\n"
          );
          this.showaddItem.ref_search = dataset.ref_search;
          if (this.showaddItem.tm_type == 3) {
            this.showaddItem.dateof_filling_affidavits = this.formatDate(
              dataset.dateof_filling_affidavits
            );
            this.dateof_filling_affidavits = dataset.dateof_filling_affidavits;

            this.showaddItem.endorsed_start = this.formatDate(
              dataset.endorsed_start
            );
            this.endorsed_start = dataset.endorsed_start;

            this.showaddItem.endorsed_end = this.formatDate(
              dataset.endorsed_end
            );
            this.endorsed_end = dataset.endorsed_end;
          }
        } else if (this.showaddItem.tm_type == 6) {
          this.showIsSearch = true;
          this.showaddItem.receive_date = this.formatDate(dataset.receive_date);
          this.receive_date = dataset.receive_date;

          this.showaddItem.startdate = this.formatDate(dataset.receive_date);
          this.startdate = dataset.receive_date;

          this.showaddItem.filling_date = this.formatDate(dataset.filling_date);
          this.filling_date = dataset.filling_date;

          this.showaddItem.enddate = this.formatDate(dataset.enddate);
          this.enddate = dataset.enddate;

          this.showaddItem.internaldate = this.formatDate(dataset.internaldate);
          this.internaldate = dataset.internaldate;
        } else if (this.showaddItem.tm_type == 10) {
          this.showIsSearch = true;
          this.showaddItem.receive_date = this.formatDate(dataset.receive_date);
          this.receive_date = dataset.receive_date;

          this.showaddItem.filling_date = this.formatDate(dataset.filling_date);
          this.filling_date = dataset.filling_date;

          this.showaddItem.good_service = (dataset.good_service || "").replace(
            /<br\s*\/?>/gi,
            "\n"
          );
        } else if (
          this.showaddItem.tm_type == 7 ||
          this.showaddItem.tm_type == 8
        ) {
          this.showaddItem.app_no = dataset.app_no;
          this.old_app_no = dataset.app_no;
          this.showaddItem.ir_no = dataset.ir_no;
          this.showaddItem.date_of_application = this.formatDate(
            dataset.date_of_application
          );
          this.date_of_application = dataset.date_of_application;
          this.showaddItem.opposed_party = dataset.opposed_party;
          this.showaddItem.date_of_opposition = this.formatDate(
            dataset.date_of_opposition
          );
          this.date_of_opposition = dataset.date_of_opposition;
          this.showaddItem.good_service = (dataset.good_service || "").replace(
            /<br\s*\/?>/gi,
            "\n"
          );
        } else if (this.showaddItem.tm_type == 9) {
          this.showaddItem.app_no = dataset.app_no;

          this.old_app_no = dataset.app_no;
          this.showaddItem.ir_no = dataset.ir_no;
          this.showaddItem.date_of_application = this.formatDate(
            dataset.date_of_application
          );
          this.date_of_application = dataset.date_of_application;

          this.showaddItem.agency = dataset.agency;
          if (dataset.date_of_infringement) {
            this.showaddItem.date_of_infringement = this.formatDate(
              dataset.date_of_infringement
            );
            this.date_of_infringement = dataset.date_of_infringement;
          }

          this.showaddItem.receive_date = this.formatDate(dataset.receive_date);
          this.receive_date = dataset.receive_date;

          this.showaddItem.filling_date = this.formatDate(dataset.filling_date);
          this.filling_date = dataset.filling_date;

          this.showaddItem.good_service = (dataset.good_service || "").replace(
            /<br\s*\/?>/gi,
            "\n"
          );

          this.showTrademarkInfringementPoliceCustoms = true;
        }
      }
    },

    async loadfiledata() {
      if (this.showaddItem.tm_type == 1 || this.showaddItem.tm_type == 3) {
        var data_search_tmimage = {
          tbl_id: Number(this.$route.params.mastertm_id),
          tbl_name: "mattertm_image",
        };

        const resultTmimage = await api.getAllFileAtLawFile({
          params: data_search_tmimage,
        });

        if (resultTmimage.data.length > 0) {
          const existingTmimage = [];
          for (const [index, item] of resultTmimage.data.entries()) {
            let data = {
              id: item.id,
              name: item.file_name,
              type: item.file_type,
            };
            existingTmimage.push(data);
          }
          this.loadExistingFiles(existingTmimage, "Tmimage");
        }

        var data_search_filling_file = {
          tbl_id: Number(this.$route.params.mastertm_id),
          tbl_name: "mattertm_filing_file",
        };

        const resultFillingFile = await api.getAllFileAtLawFile({
          params: data_search_filling_file,
        });
        if (resultFillingFile.data.length > 0) {
          const existingFilingFiles = [];
          for (const [index, item] of resultFillingFile.data.entries()) {
            let data = {
              id: item.id,
              name: item.file_name,
              type: "file",
            };

            existingFilingFiles.push(data);
          }
          this.loadExistingFiles(existingFilingFiles, "fillingFile");
        }

        var data_search_filling_cer = {
          tbl_id: Number(this.$route.params.mastertm_id),
          tbl_name: "mattertm_filing_cer",
        };

        const resultFillingCer = await api.getAllFileAtLawFile({
          params: data_search_filling_cer,
        });
        if (resultFillingCer.data.length > 0) {
          const existingFilingCer = [];
          for (const [index, item] of resultFillingCer.data.entries()) {
            let data = {
              id: item.id,
              name: item.file_name,
              type: "file",
            };

            existingFilingCer.push(data);
          }
          this.loadExistingFiles(existingFilingCer, "fillingCer");
        }
      } else if (
        this.showaddItem.tm_type == 6 ||
        this.showaddItem.tm_type == 10
      ) {
        var data_search_notic = {
          tbl_id: Number(this.$route.params.mastertm_id),
          tbl_name: "mattertm_notice",
        };

        const resultNoticFile = await api.getAllFileAtLawFile({
          params: data_search_notic,
        });
        if (resultNoticFile.data.length > 0) {
          const existingNoticeFiles = [];
          for (const [index, item] of resultNoticFile.data.entries()) {
            let data = {
              id: item.id,
              name: item.file_name,
              type: item.file_type,
            };

            existingNoticeFiles.push(data);
          }
          this.loadExistingFiles(existingNoticeFiles, "notice");
        }

        var data_search_submitted = {
          tbl_id: Number(this.$route.params.mastertm_id),
          tbl_name: "mattertm_attach",
        };

        const resultSubmittedFile = await api.getAllFileAtLawFile({
          params: data_search_submitted,
        });
        if (resultSubmittedFile.data.length > 0) {
          const existingSubmittedFiles = [];
          for (const [index, item] of resultSubmittedFile.data.entries()) {
            let data = {
              id: item.id,
              name: item.file_name,
              type: item.file_type,
            };

            existingSubmittedFiles.push(data);
          }
          this.loadExistingFiles(existingSubmittedFiles, "attach");
        }
        var data_search_tmimage = {
          tbl_id: Number(this.$route.params.mastertm_id),
          tbl_name: "mattertm_image",
        };

        const resultTmimage = await api.getAllFileAtLawFile({
          params: data_search_tmimage,
        });

        if (resultTmimage.data.length > 0) {
          const existingTmimage = [];
          for (const [index, item] of resultTmimage.data.entries()) {
            let data = {
              id: item.id,
              name: item.file_name,
              type: item.file_type,
            };
            existingTmimage.push(data);
          }
          this.loadExistingFiles(existingTmimage, "Tmimage");
        }
        if (this.showaddItem.tm_type == 10 || this.showaddItem.tm_type == 6) {
          var data_search_receipt = {
            tbl_id: Number(this.$route.params.mastertm_id),
            tbl_name: "mattertm_recicpt",
          };

          const resultFileReceipt = await api.getAllFileAtLawFile({
            params: data_search_receipt,
          });
          if (resultFileReceipt.data.length > 0) {
            const existingReceiptFiles = [];
            for (const [index, item] of resultFileReceipt.data.entries()) {
              let data = {
                id: item.id,
                name: item.file_name,
                type: item.file_type,
              };

              existingReceiptFiles.push(data);
            }
            this.loadExistingFiles(existingReceiptFiles, "receipt");
          }
        }
      } else if (
        this.showaddItem.tm_type == 7 ||
        this.showaddItem.tm_type == 8
      ) {
        var data_search_tmimage = {
          tbl_id: Number(this.$route.params.mastertm_id),
          tbl_name: "mattertm_image",
        };

        const resultTmimage = await api.getAllFileAtLawFile({
          params: data_search_tmimage,
        });

        if (resultTmimage.data.length > 0) {
          const existingTmimage = [];
          for (const [index, item] of resultTmimage.data.entries()) {
            let data = {
              id: item.id,
              name: item.file_name,
              type: item.file_type,
            };
            existingTmimage.push(data);
          }
          this.loadExistingFiles(existingTmimage, "Tmimage");
        }

        var data_search_tmimage_opposition = {
          tbl_id: Number(this.$route.params.mastertm_id),
          tbl_name: "",
        };
        if (this.showaddItem.tm_type == 7) {
          data_search_tmimage_opposition.tbl_name = "mattertm_image_opposed";
        } else {
          data_search_tmimage_opposition.tbl_name =
            "mattertm_image_cancellation";
        }

        const resultTmimageOpposition = await api.getAllFileAtLawFile({
          params: data_search_tmimage_opposition,
        });

        if (resultTmimageOpposition.data.length > 0) {
          const existingTmimageOpposition = [];
          for (const [index, item] of resultTmimageOpposition.data.entries()) {
            let data = {
              id: item.id,
              name: item.file_name,
              type: item.file_type,
            };
            existingTmimageOpposition.push(data);
          }
          this.loadExistingFiles(existingTmimageOpposition, "Oppositionimage");
        }
      } else if (this.showaddItem.tm_type == 9) {
        var data_search_tmimage = {
          tbl_id: Number(this.$route.params.mastertm_id),
          tbl_name: "mattertm_image",
        };

        const resultTmimage = await api.getAllFileAtLawFile({
          params: data_search_tmimage,
        });

        if (resultTmimage.data.length > 0) {
          const existingTmimage = [];
          for (const [index, item] of resultTmimage.data.entries()) {
            let data = {
              id: item.id,
              name: item.file_name,
              type: item.file_type,
            };
            existingTmimage.push(data);
          }
          this.loadExistingFiles(existingTmimage, "Tmimage");
        }
        var data_search_notic = {
          tbl_id: Number(this.$route.params.mastertm_id),
          tbl_name: "mattertm_notice",
        };

        const resultNoticFile = await api.getAllFileAtLawFile({
          params: data_search_notic,
        });
        if (resultNoticFile.data.length > 0) {
          const existingNoticeFiles = [];
          for (const [index, item] of resultNoticFile.data.entries()) {
            let data = {
              id: item.id,
              name: item.file_name,
              type: item.file_type,
            };

            existingNoticeFiles.push(data);
          }
          this.loadExistingFiles(existingNoticeFiles, "notice");
        }

        var data_search_submitted = {
          tbl_id: Number(this.$route.params.mastertm_id),
          tbl_name: "mattertm_attach",
        };

        const resultSubmittedFile = await api.getAllFileAtLawFile({
          params: data_search_submitted,
        });
        if (resultSubmittedFile.data.length > 0) {
          const existingSubmittedFiles = [];
          for (const [index, item] of resultSubmittedFile.data.entries()) {
            let data = {
              id: item.id,
              name: item.file_name,
              type: item.file_type,
            };

            existingSubmittedFiles.push(data);
          }
          this.loadExistingFiles(existingSubmittedFiles, "attach");
        }
        var data_search_receipt = {
          tbl_id: Number(this.$route.params.mastertm_id),
          tbl_name: "mattertm_recicpt",
        };

        const resultFileReceipt = await api.getAllFileAtLawFile({
          params: data_search_receipt,
        });
        if (resultFileReceipt.data.length > 0) {
          const existingReceiptFiles = [];
          for (const [index, item] of resultFileReceipt.data.entries()) {
            let data = {
              id: item.id,
              name: item.file_name,
              type: item.file_type,
            };

            existingReceiptFiles.push(data);
          }
          this.loadExistingFiles(existingReceiptFiles, "receipt");
        }

        var data_search_goods_service = {
          tbl_id: Number(this.$route.params.mastertm_id),
          tbl_name: "mattertm_good_service",
        };

        const resultGoodServiceFile = await api.getAllFileAtLawFile({
          params: data_search_goods_service,
        });
        if (resultGoodServiceFile.data.length > 0) {
          const existingGoodServiceFiles = [];
          for (const [index, item] of resultGoodServiceFile.data.entries()) {
            let data = {
              id: item.id,
              name: item.file_name,
              type: item.file_type,
            };
            this.oldGoodsService = data;
            existingGoodServiceFiles.push(data);
          }
          this.loadExistingFiles(existingGoodServiceFiles, "goodsService");
        }
      }
    },
    async loadDataBox() {
      if (
        this.showaddItem.tm_type == 7 ||
        this.showaddItem.tm_type == 8 ||
        this.showaddItem.tm_type == 10
      ) {
        if (this.showaddItem.tm_type == 7 || this.showaddItem.tm_type == 10) {
          // this.showTrademarkOhter = true;
          this.labels = [
            "อัปโหลดไฟล์คำวินิจฉัยของนายทะเบียน",
            "อัปโหลดไฟล์คำวินิจฉัยของชั้นคณะกรรมการ",
            "อัปโหลดไฟล์คำวินิจฉัยไปศาล",
          ];
          this.labelsDecripnt = [
            "วันที่รับคำวินิจฉัยของนายทะเบียน",
            "วันที่รับคำวินิจฉัยของชั้นคณะกรรมการ",
            "วันที่รับคำวินิจฉัยไปศาล",
          ];
        } else if (this.showaddItem.tm_type == 8) {
          this.labels = [
            "อัปโหลดไฟล์คำวินิจฉัยของชั้นคณะกรรมการ",
            "อัปโหลดไฟล์คำวินิจฉัยไปศาล",
          ];
          this.labelsDecripnt = [
            "วันที่รับคำวินิจฉัยของชั้นคณะกรรมการ",
            "วันที่รับคำวินิจฉัยไปศาล",
          ];
        }
        const resDiscision = await api.getdecisiongetByAppId(
          Number(this.$route.params.mastertm_id),
          `matterTM`
        );
        this.decisionBoxes = [];

        if (resDiscision.data.length > 0) {
          for (const [index, item] of resDiscision.data.entries()) {
            let datalist = {
              id: item.id,
              date: item.date,
              files: [],
              level: item.level,
              menuReceiveBox: false,
              result: item.result,
            };
            var dataSearchDecisions = {
              tbl_id: Number(this.$route.params.mastertm_id),
              tbl_name: "",
            };
            if (item.level == 1) {
              dataSearchDecisions.tbl_name = `mattertm_decision_level1`;
            } else if (item.level == 2) {
              dataSearchDecisions.tbl_name = `mattertm_decision_level2`;
            } else if (item.level == 3) {
              dataSearchDecisions.tbl_name = `mattertm_decision_level3`;
            }
            var resDiscisionFileList = await api.getAllFileAtLawFile({
              params: dataSearchDecisions,
            });

            if (resDiscisionFileList.data.length > 0) {
              let filesBox = resDiscisionFileList.data.map((f) => {
                // สร้าง File object เปล่าเพื่อใช้ preview
                const file = new File([], f.file_name, {
                  type: f.type || "application/octet-stream",
                });

                // เพิ่ม property พิเศษเข้าไป
                file.isOld = true;
                file.id = f.id;
                file.keyType = "file"; // << ตามที่คุณบอก key type = file

                return file;
              });
              datalist.files = filesBox;
              this.dataFileAll.push(...filesBox.map((f) => f.name));
            }

            this.decisionBoxes.push(datalist);
          }
          this.indexLengthBox = resDiscision.data.length;
        }
      }
    },
    async loaddataPriority() {
      if (this.showaddItem.tm_type == 1 || this.showaddItem.tm_type == 3) {
        const res_priority = await api.getAllMASTERPT_PRIORITY_BYIDTM(
          Number(this.$route.params.mastertm_id)
        );
        if (res_priority.data.length > 0) {
          this.priorityList = [];
          this.priorityListOld = [];
          res_priority.data.forEach((item) => {
            this.priorityListOld.push(item.id);

            this.priorityList.push({
              id: item.id,
              number: item.priority_number,
              date:
                item.priority_date === "1970-01-01" ? null : item.priority_date,
              country: item.priority_country,
              menu: false,
            });
          });
        }
      }
    },
    loadExistingFiles(existingFiles, type) {
      if (!existingFiles || existingFiles.length === 0) return;

      const files = existingFiles.map((f) => {
        // สร้าง File object เปล่าสำหรับ preview
        const file = new File([], f.name, {
          type: f.type || "application/octet-stream",
        });
        // เพิ่ม property isNew เข้าไปใน File object
        file.isOld = true;
        file.id = f.id;
        return file;
      });

      switch (type) {
        case "notice":
          this.image_listnotice = files;
          this.filenamenotice = files.map((f) => f.name);
          break;
        case "fillingFile":
          this.image_list = files;
          this.filename = files.map((f) => f.name);
          break;
        case "fillingCer":
          this.image_list_cer = files;
          this.filename_cer = files.map((f) => f.name);
          break;

        case "attach":
          this.image_listattach = files;
          this.filenameattach = files.map((f) => f.name);
          break;

        case "Tmimage":
          this.images = files;
          // ✅ สำหรับ preview เก่า ใช้ path URL จริง ไม่ใช่ File object
          this.previews = files.map(
            (f) =>
              `${imagemasterTMUrl}/${this.$route.params.mastertm_id}/${f.name}`
          );
          this.imagenames = files.map((f) => f.name);
          break;

        case "Oppositionimage":
          this.imagesOpposed = files;
          // ✅ สำหรับ preview เก่า ใช้ path URL จริง ไม่ใช่ File object
          this.previewsOpposed = files.map(
            (f) =>
              `${imagemasterTMUrl}/${this.$route.params.mastertm_id}/${f.name}`
          );
          this.imagenamesOpposed = files.map((f) => f.name);
          break;
        case "receipt":
          this.image_listrecicpt = files;
          this.filenamerecive = files.map((f) => f.name);
          break;
        case "goodsService":
          this.fileList_good_service = files;
          break;
      }
      // // --- ป้องกันชื่อซ้ำกับไฟล์ใหม่ ---
      this.dataFileAll.push(...files.map((f) => f.name));
    },
    onFileChange(type, event) {
      const files = Array.from(event.target.files);

      // กำหนด allowed types ตาม type
      let allowedTypes = [
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/pdf",
      ];

      if (type === "good_service") allowedTypes = ["text/csv"];
      if (type === "decision") allowedTypes = ["application/pdf"];

      const newFiles = files.filter((file) => {
        if (type === "good_service") {
          return (
            allowedTypes.includes(file.type) ||
            file.name.toLowerCase().endsWith(".csv")
          );
        } else if (type === "decision") {
          return (
            allowedTypes.includes(file.type) ||
            file.name.toLowerCase().endsWith(".pdf")
          );
        } else {
          return (
            allowedTypes.includes(file.type) ||
            file.name.toLowerCase().endsWith(".doc") ||
            file.name.toLowerCase().endsWith(".docx") ||
            file.name.toLowerCase().endsWith(".pdf")
          );
        }
      });

      if (!newFiles.length) {
        let msg = "กรุณาเลือกไฟล์ Word หรือ PDF";
        if (type === "good_service") msg = "กรุณาเลือกไฟล์ CSV เท่านั้น";
        if (type === "decision") msg = "กรุณาเลือกไฟล์ PDF เท่านั้น";
        alert(msg);
        return;
      }

      // เลือก list ของ type
      let list;
      if (type === "search") list = this.fileList_search;
      else if (type === "submitted") list = this.fileList_submitted;
      else if (type === "notice") list = this.fileList_notice;
      else if (type === "receipt") list = this.fileList_receipt;
      else if (type === "good_service") list = this.fileList_good_service;
      else if (type === "decision") list = this.fileList_decision;

      list.push(...newFiles);

      // เรียง PDF ก่อน สำหรับ good_service ไม่มี PDF จึงไม่กระทบ
      list.sort((a, b) => {
        const isPdfA = a.name.toLowerCase().endsWith(".pdf");
        const isPdfB = b.name.toLowerCase().endsWith(".pdf");
        if (isPdfA && !isPdfB) return -1;
        if (!isPdfA && isPdfB) return 1;
        return 0;
      });

      event.target.value = "";
    },

    removeFile(type, index) {
      let list;
      if (type === "search") list = this.fileList_search;
      else if (type === "submitted") list = this.fileList_submitted;
      else if (type === "notice") list = this.fileList_notice;
      else if (type === "receipt") list = this.fileList_receipt;
      else if (type === "good_service") list = this.fileList_good_service;
      else if (type === "decision") list = this.fileList_decision;

      list.splice(index, 1);
    },

    fileUrl(file) {
      return URL.createObjectURL(file);
    },

    onSelectNextRenewalDate(value) {
      // value = "YYYY-MM-DD"
      this.menurenewal = false;

      // set Next Renewal Date
      this.showaddItem.date_of_renewal = this.formatDate(value);

      // คำนวณ -90 วัน
      const date = new Date(value); // แปลงเป็น Date object
      date.setDate(date.getDate() - 90);

      // แปลงกลับเป็น DD/MM/YYYY
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      this.showaddItem.date_of_renewal_filed = `${day}/${month}/${year}`;
    },
    onSelectFinalDeadlineSearch(value) {
      if (Number(this.showaddItem.tm_type) == 6) {
        // value = "YYYY-MM-DD"
        this.menuStart = false;

        // set Next Renewal Date
        this.showaddItem.enddate = this.formatDate(value);

        // คำนวณ -7 วัน
        const date = new Date(value); // แปลงเป็น Date object
        date.setDate(date.getDate() - 7);

        // แปลงกลับเป็น DD/MM/YYYY
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        this.showaddItem.internaldate = `${day}/${month}/${year}`;
      } else {
        // value = "YYYY-MM-DD"
        this.menuStart = false;

        // set Next Renewal Date
        this.showaddItem.enddate = this.formatDate(value);

        // คำนวณ -90 วัน
        const date = new Date(value); // แปลงเป็น Date object
        date.setDate(date.getDate() - 7);

        // แปลงกลับเป็น DD/MM/YYYY
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        this.showaddItem.internaldate = `${day}/${month}/${year}`;
      }
    },
    onSelectFinalDeadlineTrademarkOppositionOthers(value) {
      // value = "YYYY-MM-DD"
      this.menuStart = false;

      // set Next Renewal Date
      this.showaddItem.enddate = this.formatDate(value);

      // แปลงเป็น Date object
      const date = new Date(value);

      // ลบ 1 เดือน ตามปฏิทิน
      const currentMonth = date.getMonth();
      date.setMonth(currentMonth - 1);

      // แปลงกลับเป็น DD/MM/YYYY
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      this.showaddItem.internaldate = `${day}/${month}/${year}`;
    },
    onSelectfilling_dateTrademarkOppositionOthers(value) {
      // value = "YYYY-MM-DD"
      this.menuFilling = false;

      // set filling_date
      this.showaddItem.filling_date = this.formatDate(value);

      // แปลงเป็น Date object
      const date = new Date(value);

      // บวก 60 วัน
      date.setDate(date.getDate() + 60);

      // แปลงกลับเป็น DD/MM/YYYY
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      this.showaddItem.enddate = `${day}/${month}/${year}`;

      // เรียก onSelectFinalDeadlineTrademarkOppositionOthers ต่อ
      // แปลงเป็น YYYY-MM-DD สำหรับส่ง
      const nextValue = `${year}-${month}-${day}`;
      this.onSelectFinalDeadlineTrademarkOppositionOthers(nextValue);
    },
    setDefluatData() {
      this.showaddItem.date_of_renewal = "";
      this.showaddItem.date_of_renewal_filed = "";
      this.date_of_renewal = "";
      this.date_of_renewal_filed = "";

      //upload trademark image
      this.images = [];
      this.imagenames = [];
      this.previews = [];
      this.checkimageadd = false;

      //upload file
      this.image_list = [];
      this.filename = [];
      this.getpreview_list = [];
      this.preview_list = [];
      this.preview_list2 = [];
      this.checkfileeadd = false;

      //upload cer
      this.image_list_cer = [];
      this.filename_cer = [];
      this.getpreview_list_cer = [];
      this.preview_list_cer = [];
      this.preview_list2_cer = [];
      this.checkfileeadd_cer = false;

      //search file
      this.fileList_search = [];
    },
    calDateFinalDeadline() {
      if (Number(this.showaddItem.tm_type) == 6) {
      } else {
        const [year, month, day] = this.receive_date.split("-").map(Number);
        const date = new Date(year, month - 1, day);

        // คำนวณ enddate = receive_date + 5 ปี - 1 วัน
        date.setFullYear(date.getFullYear() + 5);
        date.setDate(date.getDate() - 1);

        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, "0");
        const d = String(date.getDate()).padStart(2, "0");
        this.showaddItem.enddate = `${d}/${m}/${y}`;

        // internaldate = enddate - 7 วัน
        const internalDate = new Date(date);
        internalDate.setDate(internalDate.getDate() - 7);

        const iy = internalDate.getFullYear();
        const im = String(internalDate.getMonth() + 1).padStart(2, "0");
        const id = String(internalDate.getDate()).padStart(2, "0");
        this.showaddItem.internaldate = `${id}/${im}/${iy}`;
      }
    },
    formatDatePriority(date) {
      if (!date) return "";
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDateInputPriority(value) {
      if (!value) return "";
      const parts = value.split("/");
      if (parts.length === 3) {
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
      }
      return value; // fallback ถ้า format ไม่ถูกต้อง
    },
    addPriority() {
      this.priorityList.push({
        id: 0,
        number: "",
        date: "",
        country: "",
        menu: false,
      });
    },
    removePriority(index) {
      this.priorityList.splice(index, 1);
    },

    async saveaddItem(modeOper) {
      if (this.showaddItem.tm_type == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please enter Object Type Data",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.showaddItem.file_no == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please enter File No. Data",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (this.old_file_no != this.showaddItem.file_no.trim()) {
        var checkfileNo = await api.CheckTMFileNo(this.showaddItem.file_no);

        if (checkfileNo.data.length > 0) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Data Duplicate ",
            "Please check File No.",
            "text-h5 red--text text-center"
          );
          return;
        }
      }
      if (Number(this.showaddItem.tm_type) == 6) {
        if (!this.showaddItem.receive_date) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please enter Receive Date",
            "text-h5 red--text text-center"
          );
          return;
        }
        if (!this.showaddItem.enddate) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please enter Final Deadline",
            "text-h5 red--text text-center"
          );
          return;
        }
        if (!this.showaddItem.internaldate) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please enter Fixed Internal Date",
            "text-h5 red--text text-center"
          );
          return;
        }
      } else if (Number(this.showaddItem.tm_type) == 10) {
        if (!this.showaddItem.receive_date) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please enter Receive Date",
            "text-h5 red--text text-center"
          );
          return;
        }
        for (const [index, item] of this.decisionBoxes.entries()) {
          if (!item.date || !item.result) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Check data",
              "Please Put Decision Document Data",
              "text-h5 red--text text-center"
            );
            return; // ออกจากฟังก์ชันทันที
          }
        }
      } else if (
        // Number(this.showaddItem.tm_type) == 7 ||
        Number(this.showaddItem.tm_type) == 8
      ) {
        if (
          this.showaddItem.app_no.trim() != "" &&
          this.old_app_no != this.showaddItem.app_no.trim()
        ) {
          var checkAppno = await api.CheckTMAppNp(this.showaddItem.app_no);
          if (checkAppno.data.length > 0) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Data Duplicate ",
              "Please check Application No.",
              "text-h5 red--text text-center"
            );
            return;
          }
        }
        for (const [index, item] of this.decisionBoxes.entries()) {
          if (!item.date || !item.result) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Check data",
              "Please Put Decision Document Data",
              "text-h5 red--text text-center"
            );
            return; // ออกจากฟังก์ชันทันที
          }
        }
      } else if (Number(this.showaddItem.tm_type) == 9) {
        if (
          this.showaddItem.app_no.trim() != "" &&
          this.old_app_no != this.showaddItem.app_no.trim()
        ) {
          var checkAppno = await api.CheckTMAppNp(this.showaddItem.app_no);
          if (checkAppno.data.length > 0) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Data Duplicate ",
              "Please check Application No.",
              "text-h5 red--text text-center"
            );
            return;
          }
        }
        if (!this.showaddItem.receive_date) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please enter Receive Date",
            "text-h5 red--text text-center"
          );
          return;
        }
        if (!this.showaddItem.filling_date) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please enter Submit Date",
            "text-h5 red--text text-center"
          );
          return;
        }
      }

      var dataAdd = {
        file_no: "",
        regis_no: "",
        tm_type: 0,
        class_no: "",
        country: "",
        master_images: "",
        master_files: "",
        date_of_filling: null,
        name_of_client: "",
        date_of_regis: null,
        cliant_ref: "",
        app_no: "",
        date_of_application: null,
        trademark: "",
        owner_contact: "",
        agent_contact: 0,
        associate_contact: 0,
        date_of_public: null,
        date_of_filling_appeal: null,
        good_service: "",
        val_no: "",
        date_of_filling_lawsuit: null,
        remark: "",
        page_no: "",
        date_of_renewal: null,
        condition_of_regis: "",
        date_of_opposition: null,
        date_of_renewal_filed: null,
        last_update: null,
        next_deadline: null,
        dateof_filling_affidavits: null,
        lawyer: "",
        tmstatusasoff: 0,
        dip_link: "",
        key_by: "",
        images_update: null,
        updatestatus: 0,
        madrid: 0,
        recordal: 0,
        recordalstatus: 0,
        provisional: 0,
        closed: 0,
        disclaim: "",
        date_of_closed: null,
        date_of_issuing_certificate: 0,
        created_at: null,
        updated_at: null,
        user_update: null,

        receive_date: null,
        filling_date: null,
        enddate: null,
        internaldate: null,

        ir_no: "",
        opposed_party: "",
        ref_search: 0,
        cus_billing_id: 0,
        date_of_infringement: null,
        agency: "",
        send_billing: "",
        send_billing_detail: "",
      };

      //set all data
      dataAdd.cus_billing_id = this.customer_selected
        ? this.customer_selected
        : null;
      dataAdd.send_billing = this.sendBilling;
      if (this.sendBilling == "Reply All") {
        dataAdd.send_billing_detail = "";
      } else {
        dataAdd.send_billing_detail = this.sendBillingDetail;
      }
      dataAdd.file_no = this.showaddItem.file_no.trim();
      dataAdd.tm_type = Number(this.showaddItem.tm_type);
      dataAdd.country = this.showaddItem.country.trim();
      dataAdd.app_no = this.showaddItem.app_no.trim();
      dataAdd.trademark = this.showaddItem.trademark.trim();
      dataAdd.class_no = this.showaddItem.class_no.trim();
      if (this.owner_contact_list.length > 0) {
        dataAdd.owner_contact = this.owner_contact_list
          .map((item) => item.contact_id)
          .join(",");

        dataAdd.name_of_client = this.owner_contact_list
          .map((item) => item.contact_name)
          .join(", ");
      }

      dataAdd.cliant_ref = this.showaddItem.cliant_ref;
      dataAdd.agent_contact = this.showaddItem.agent_contact;
      dataAdd.associate_contact = this.showaddItem.associate_contact;
      dataAdd.tmstatusasoff = this.showaddItem.tmstatusasoff;
      dataAdd.last_update = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);

      dataAdd.images_update = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .replace("T", " ")
        .substr(0, 19);
      dataAdd.remark = this.showaddItem.remark;
      dataAdd.user_create = Number(localStorage.getItem(server.USER_ID));
      if (
        Number(this.showaddItem.tm_type) == 1 ||
        Number(this.showaddItem.tm_type) == 3
      ) {
        dataAdd.ir_no = this.showaddItem.ir_no;
        dataAdd.date_of_application = this.changeformatDatetoinsert(
          this.showaddItem.date_of_application
        );
        dataAdd.date_of_public = this.changeformatDatetoinsert(
          this.showaddItem.date_of_public
        );
        dataAdd.regis_no = this.showaddItem.regis_no;
        dataAdd.date_of_regis = this.changeformatDatetoinsert(
          this.showaddItem.date_of_regis
        );
        dataAdd.date_of_issuing_certificate = this.changeformatDatetoinsert(
          this.showaddItem.date_of_issuing_certificate
        );
        dataAdd.date_of_renewal_filed = this.changeformatDatetoinsert(
          this.showaddItem.date_of_renewal_filed
        );
        dataAdd.date_of_renewal = this.changeformatDatetoinsert(
          this.showaddItem.date_of_renewal
        );
        dataAdd.good_service = this.showaddItem.good_service;
        dataAdd.ref_search = this.showaddItem.ref_search;
        if (Number(this.showaddItem.tm_type) == 3) {
          dataAdd.endorsed_start = this.changeformatDatetoinsert(
            this.showaddItem.endorsed_start
          );
          dataAdd.endorsed_end = this.changeformatDatetoinsert(
            this.showaddItem.endorsed_end
          );
          dataAdd.dateof_filling_affidavits = this.changeformatDatetoinsert(
            this.showaddItem.dateof_filling_affidavits
          );
        }
      } else if (Number(this.showaddItem.tm_type) == 6) {
        dataAdd.receive_date = this.changeformatDatetoinsert(
          this.showaddItem.receive_date
        );
        dataAdd.filling_date = this.changeformatDatetoinsert(
          this.showaddItem.filling_date
        );
        dataAdd.enddate = this.changeformatDatetoinsert(
          this.showaddItem.enddate
        );
        dataAdd.internaldate = this.changeformatDatetoinsert(
          this.showaddItem.internaldate
        );
      } else if (Number(this.showaddItem.tm_type) == 10) {
        dataAdd.receive_date = this.changeformatDatetoinsert(
          this.showaddItem.receive_date
        );
        dataAdd.filling_date = this.changeformatDatetoinsert(
          this.showaddItem.filling_date
        );
        dataAdd.good_service = this.showaddItem.good_service;
        dataAdd.date_of_application = dataAdd.receive_date;
      } else if (
        Number(this.showaddItem.tm_type) == 7 ||
        Number(this.showaddItem.tm_type) == 8
      ) {
        dataAdd.ir_no = this.showaddItem.ir_no;
        dataAdd.date_of_application = this.changeformatDatetoinsert(
          this.showaddItem.date_of_application
        );

        dataAdd.opposed_party = this.showaddItem.opposed_party;
        dataAdd.date_of_opposition = this.changeformatDatetoinsert(
          this.showaddItem.date_of_opposition
        );
        dataAdd.good_service = this.showaddItem.good_service;
      } else if (Number(this.showaddItem.tm_type) == 9) {
        dataAdd.ir_no = this.showaddItem.ir_no;

        dataAdd.date_of_application = this.changeformatDatetoinsert(
          this.showaddItem.date_of_application
        );
        dataAdd.date_of_infringement = this.changeformatDatetoinsert(
          this.showaddItem.date_of_infringement
        );
        dataAdd.agency = this.showaddItem.agency;
        dataAdd.receive_date = this.changeformatDatetoinsert(
          this.showaddItem.receive_date
        );
        dataAdd.filling_date = this.changeformatDatetoinsert(
          this.showaddItem.filling_date
        );

        if (this.oldGoodsService.name != "") {
          if (this.fileList_good_service.length > 0) {
            for (const [index, item] of this.fileList_good_service.entries()) {
              if (item.name != this.oldGoodsService.name) {
                for (const file of this.fileList_good_service) {
                  const csvText = await new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = (e) => resolve(e.target.result);
                    reader.onerror = (err) => reject(err);
                    reader.readAsText(file); // อ่านเป็น text
                  });
                  // แปลง CSV เป็น array ของ object (สมมติว่า CSV มี header)
                  const lines = csvText
                    .split(/\r?\n/)
                    .filter((line) => line.trim() !== "");
                  const headers = lines[0].split(",").map((h) => h.trim());
                  const dataRows = lines.slice(1).map((line) => {
                    const values = line.split(",").map((v) => v.trim());
                    const obj = {};
                    headers.forEach((h, i) => {
                      obj[h] = values[i] ?? null;
                    });
                    return obj;
                  });
                  // จัดกลุ่ม product ตาม class
                  const grouped = dataRows.reduce((acc, item) => {
                    if (!acc[item.class]) acc[item.class] = [];
                    acc[item.class].push(item.product);
                    return acc;
                  }, {});
                  // สร้าง string แสดง class + product
                  const classKeys = Object.keys(grouped);
                  let resultHTML = "";
                  classKeys.forEach((cls, idx) => {
                    const products = grouped[cls];
                    const productStr =
                      products.length > 1 ? products.join(", ") : products[0];
                    resultHTML += `${cls}: ${productStr}`;
                    // ใส่ <br /> เฉพาะถ้าไม่ใช่ class ตัวสุดท้าย
                    if (idx !== classKeys.length - 1) resultHTML += "<br />";
                  });
                  dataAdd.good_service = resultHTML;
                }
              }
            }
          } else {
            dataAdd.good_service = "";
          }
        } else {
          if (this.fileList_good_service.length > 0) {
            for (const file of this.fileList_good_service) {
              const csvText = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result);
                reader.onerror = (err) => reject(err);
                reader.readAsText(file); // อ่านเป็น text
              });
              // แปลง CSV เป็น array ของ object (สมมติว่า CSV มี header)
              const lines = csvText
                .split(/\r?\n/)
                .filter((line) => line.trim() !== "");
              const headers = lines[0].split(",").map((h) => h.trim());
              const dataRows = lines.slice(1).map((line) => {
                const values = line.split(",").map((v) => v.trim());
                const obj = {};
                headers.forEach((h, i) => {
                  obj[h] = values[i] ?? null;
                });
                return obj;
              });
              // จัดกลุ่ม product ตาม class
              const grouped = dataRows.reduce((acc, item) => {
                if (!acc[item.class]) acc[item.class] = [];
                acc[item.class].push(item.product);
                return acc;
              }, {});
              // สร้าง string แสดง class + product
              const classKeys = Object.keys(grouped);
              let resultHTML = "";
              classKeys.forEach((cls, idx) => {
                const products = grouped[cls];
                const productStr =
                  products.length > 1 ? products.join(", ") : products[0];
                resultHTML += `${cls}: ${productStr}`;
                // ใส่ <br /> เฉพาะถ้าไม่ใช่ class ตัวสุดท้าย
                if (idx !== classKeys.length - 1) resultHTML += "<br />";
              });
              dataAdd.good_service = resultHTML;
            }
          }
        }
      }

      try {
        this.$showLoader();
        var resadddata = await api.UpdateNewTm(
          Number(this.$route.params.mastertm_id),
          dataAdd
        );

        if (resadddata.status == 201) {
          if (Number(dataAdd.tmstatusasoff) == 6) {
            await api.updateCloseApp(this.showaddItem.file_no);
          }
          if (this.removeNoticFile.length > 0) {
            for (const [index, item] of this.removeNoticFile.entries()) {
              var datadel = {
                id: item.id,
                name: item.name,
                type: "file",
                masterId: Number(this.$route.params.mastertm_id),
              };
              await api.ip_deleteByTrademarkID(datadel);
            }
          }
          if (this.image_listnotice.length > 0) {
            this.image_listnotice.forEach(async (item) => {
              if (!item.isOld) {
                let formData = new FormData();
                formData.set("file", item);
                formData.set("fileName", item.name);
                formData.set("fileTypeAdd", `notice`);
                await api.CreateFileMatterTm(
                  Number(this.$route.params.mastertm_id),
                  formData
                );
              }
            });
          }
          if (this.removeAttactFile.length > 0) {
            for (const [index, item] of this.removeAttactFile.entries()) {
              var datadel = {
                id: item.id,
                name: item.name,
                type: "file",
                masterId: Number(this.$route.params.mastertm_id),
              };
              await api.ip_deleteByTrademarkID(datadel);
            }
          }
          if (this.image_listattach.length > 0) {
            this.image_listattach.forEach(async (item) => {
              if (!item.isOld) {
                let formData = new FormData();
                formData.set("file", item);
                formData.set("fileName", item.name);
                formData.set("fileTypeAdd", `attach`);
                await api.CreateFileMatterTm(
                  Number(this.$route.params.mastertm_id),
                  formData
                );
              }
            });
          }

          if (this.removeTMimageFile.length > 0) {
            for (const [index, item] of this.removeTMimageFile.entries()) {
              var datadel = {
                id: item.id,
                name: item.name,
                type: "image",
                masterId: Number(this.$route.params.mastertm_id),
              };
              await api.ip_deleteByTrademarkID(datadel);
            }
          }
          if (this.images.length > 0) {
            this.images.forEach(async (item) => {
              if (!item.isOld) {
                let formData = new FormData();
                formData.set("file", item);
                formData.set("fileName", item.name);
                formData.set("fileTypeAdd", `image`);
                await api.CreateFileMatterTm(
                  Number(this.$route.params.mastertm_id),
                  formData
                );
              }
            });
          }
          if (this.removeTMimageOppFile.length > 0) {
            for (const [index, item] of this.removeTMimageOppFile.entries()) {
              var datadel = {
                id: item.id,
                name: item.name,
                type: "image",
                masterId: Number(this.$route.params.mastertm_id),
              };
              await api.ip_deleteByTrademarkID(datadel);
            }
          }
          if (this.imagesOpposed.length > 0) {
            this.imagesOpposed.forEach(async (item) => {
              if (!item.isOld) {
                let formData = new FormData();
                formData.set("file", item);
                formData.set("fileName", item.name);
                if (Number(this.showaddItem.tm_type) == 7) {
                  formData.set("fileTypeAdd", `image_opposed`);
                } else if (Number(this.showaddItem.tm_type) == 8) {
                  formData.set("fileTypeAdd", `image_cancellation`);
                }
                await api.CreateFileMatterTm(
                  Number(this.$route.params.mastertm_id),
                  formData
                );
              }
            });
          }
          if (
            this.showaddItem.tm_type == 1 ||
            Number(this.showaddItem.tm_type) == 3
          ) {
            if (this.removeFillingFile.length > 0) {
              for (const [index, item] of this.removeFillingFile.entries()) {
                let deldata = {
                  id: item.id,
                  name: item.name,
                  type: `file`,
                  masterId: Number(this.$route.params.mastertm_id),
                };
                await api.ip_deleteByTrademarkID(deldata);
              }
            }
            if (this.image_list.length > 0) {
              this.image_list.forEach(async (item) => {
                if (!item.isOld) {
                  let formData = new FormData();
                  formData.set("file", item);
                  formData.set("fileName", item.name);
                  formData.set("fileTypeAdd", `filing_file`);
                  await api.CreateFileMatterTm(
                    Number(this.$route.params.mastertm_id),
                    formData
                  );
                }
              });
            }
            if (this.removeFillingCer.length > 0) {
              for (const [index, item] of this.removeFillingCer.entries()) {
                let deldata = {
                  id: item.id,
                  name: item.name,
                  type: `file`,
                  masterId: Number(this.$route.params.mastertm_id),
                };
                await api.ip_deleteByTrademarkID(deldata);
              }
            }
            if (this.image_list_cer.length > 0) {
              this.image_list_cer.forEach(async (item) => {
                if (!item.isOld) {
                  let formData = new FormData();
                  formData.set("file", item);
                  formData.set("fileName", item.name);
                  formData.set("fileTypeAdd", `filing_cer`);
                  await api.CreateFileMatterTm(
                    Number(this.$route.params.mastertm_id),
                    formData
                  );
                }
              });
            }
            if (this.priorityListOld.length > 0) {
              const notFoundIds = this.priorityListOld.filter(
                (id) => !this.priorityList.some((item) => item.id === id)
              );
              for (const [index, item] of notFoundIds.entries()) {
                await api.deleteMASTERPTPRIORITY(item);
              }
            }
            for (const [index, item] of this.priorityList.entries()) {
              if (item.id == 0) {
                var data_add_riority = {
                  masterpt_id: Number(this.$route.params.mastertm_id),
                  priority_number: item.number,
                  priority_date: item.date,
                  priority_country: item.country,
                  master_type: `MasterTM`,
                };

                if (
                  item.number != "" ||
                  item.date != "" ||
                  item.country != ""
                ) {
                  await api.createMASTERPT_PRIORITY(data_add_riority);
                }
              } else {
                var data_update_riority = {
                  priority_number: item.number,
                  priority_date: item.date,
                  priority_country: item.country,
                };

                if (
                  item.number != "" ||
                  item.date != "" ||
                  item.country != ""
                ) {
                  await api.updateMASTERPTPRIORITY(
                    item.id,
                    data_update_riority
                  );
                }
              }
            }
          } else if (
            this.showaddItem.tm_type == 7 ||
            this.showaddItem.tm_type == 8 ||
            this.showaddItem.tm_type == 10
          ) {
            if (this.removeBoxFile.length > 0) {
              for (const [index, item] of this.removeBoxFile.entries()) {
                await api.ip_deleteByTrademarkID(item);
              }
            }
            for (const [index, item] of this.decisionBoxes.entries()) {
              if (item.files.length > 0) {
                for (const file of item.files) {
                  if (!file.isOld) {
                    let formData = new FormData();
                    formData.set("file", file);
                    formData.set("fileName", file.name);
                    formData.set("fileTypeAdd", `decision_level${item.level}`);
                    await api.CreateFileMatterTm(
                      Number(this.$route.params.mastertm_id),
                      formData
                    );
                  }
                }
              }
              if (item.id != 0) {
                var dataDecisionDocumentAdd = {
                  appointment_id: this.$route.params.mastertm_id,
                  level: item.level,
                  result: item.result,
                  date: item.date,
                  type: `matterTM`,
                };
                await api.updatedecision(
                  Number(item.id),
                  dataDecisionDocumentAdd
                );
              } else {
                var dataDecisionDocumentAdd = {
                  appointment_id: this.$route.params.mastertm_id,
                  level: item.level,
                  result: item.result,
                  date: item.date,
                  type: `matterTM`,
                };
                await api.createdecision(dataDecisionDocumentAdd);
              }
            }
          }
          if (this.showaddItem.tm_type == 6) {
            if (this.removeReciveFile.length > 0) {
              for (const [index, item] of this.removeReciveFile.entries()) {
                var datadel = {
                  id: item.id,
                  name: item.name,
                  type: "image",
                  masterId: Number(this.$route.params.mastertm_id),
                };
                await api.ip_deleteByTrademarkID(datadel);
              }
            }
            if (this.image_listrecicpt.length > 0) {
              this.image_listrecicpt.forEach(async (item) => {
                if (!item.isOld) {
                  let formData = new FormData();
                  formData.set("file", item);
                  formData.set("fileName", item.name);
                  formData.set("fileTypeAdd", `recicpt`);
                  await api.CreateFileMatterTm(
                    Number(this.$route.params.mastertm_id),
                    formData
                  );
                }
              });
            }
          }
          if (this.showaddItem.tm_type == 9 || this.showaddItem.tm_type == 10) {
            if (this.removeReciveFile.length > 0) {
              for (const [index, item] of this.removeReciveFile.entries()) {
                var datadel = {
                  id: item.id,
                  name: item.name,
                  type: "image",
                  masterId: Number(this.$route.params.mastertm_id),
                };
                await api.ip_deleteByTrademarkID(datadel);
              }
            }
            if (this.image_listrecicpt.length > 0) {
              this.image_listrecicpt.forEach(async (item) => {
                if (!item.isOld) {
                  let formData = new FormData();
                  formData.set("file", item);
                  formData.set("fileName", item.name);
                  formData.set("fileTypeAdd", `recicpt`);
                  await api.CreateFileMatterTm(
                    Number(this.$route.params.mastertm_id),
                    formData
                  );
                }
              });
            }
            if (this.showaddItem.tm_type != 10) {
              if (this.oldGoodsService.name != "") {
                if (this.fileList_good_service.length > 0) {
                  for (const [
                    index,
                    item,
                  ] of this.fileList_good_service.entries()) {
                    if (item.name != this.oldGoodsService.name) {
                      var datadel = {
                        id: this.oldGoodsService.id,
                        name: this.oldGoodsService.name,
                        type: "file",
                        masterId: Number(this.$route.params.mastertm_id),
                      };
                      await api.ip_deleteByTrademarkID(datadel);

                      let formData = new FormData();
                      formData.set("file", item);
                      formData.set("fileName", item.name);
                      formData.set("fileTypeAdd", `good_service`);
                      await api.CreateFileMatterTm(
                        Number(this.$route.params.mastertm_id),
                        formData
                      );
                    }
                  }
                } else {
                  var datadel = {
                    id: this.oldGoodsService.id,
                    name: this.oldGoodsService.name,
                    type: "file",
                    masterId: Number(this.$route.params.mastertm_id),
                  };
                  await api.ip_deleteByTrademarkID(datadel);
                }
              } else {
                if (this.fileList_good_service.length > 0) {
                  this.fileList_good_service.forEach(async (item) => {
                    let formData = new FormData();
                    formData.set("file", item);
                    formData.set("fileName", item.name);
                    formData.set("fileTypeAdd", `good_service`);
                    await api.CreateFileMatterTm(
                      Number(this.$route.params.mastertm_id),
                      formData
                    );
                  });
                }
              }
            }
          }

          var dataAdd = {
            user_id: localStorage.getItem(server.USER_ID),
            log_in_out_id: localStorage.getItem(server.LOGIN_ID),
            action: "Update",
            table_name: "mastertm",
            table_id: Number(this.$route.params.mastertm_id),
            date: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
          };
          await api.addTransectionLogCoreApi(dataAdd);
          var dataEditLog = {
            last_update: moment()
              .tz("Asia/Bangkok")
              .format("YYYY-MM-DD HH:mm:ss"),
          };
          await api.updateLogInOutLog(
            localStorage.getItem(server.LOGIN_ID),
            dataEditLog
          );

          this.$hideLoader();
          if (modeOper == "createDocket") {
            this.dialogAddmastertm = false;
            this.$store.state.global_push_dialog = true;
            this.setupAlertDialogPush(
              true,
              "save data",
              "save data success",
              "text-h5 green--text text-center",
              `/appointmenttm-add/${this.showaddItem.file_no}/null`
            );
            return;
          } else {
            this.dialogAddmastertm = false;
            this.$store.state.global_push_dialog = true;
            this.setupAlertDialogPush(
              true,
              "save data",
              "save data success",
              "text-h5 green--text text-center",
              "/master-trademark-list"
            );
            return;
          }
        }
      } catch (error) {
        this.$hideLoader(); // ซ่อน loader ถ้ามี
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          false,
          "save data",
          "save data failed: ",
          "text-h5 red--text text-center",
          null
        );
      }
    },

    async saveandcreateappointmentaddItem() {
      if (this.showaddItem.tm_type == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please enter Object Type Data",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.showaddItem.file_no == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please enter File No. Data",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.showaddItem.trademark == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please enter Trademark Data",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (
        !this.showaddItem.date_of_application ||
        this.showaddItem.date_of_application == ""
      ) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please enter Application Date Data",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (
        this.showaddItem.closed == true &&
        this.showaddItem.date_of_closed == ""
      ) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please enter Closed File Date Data",
          "text-h5 red--text text-center"
        );
        return;
      }

      this.$showLoader();
      let formData = new FormData();
      formData.append(`file`, this.image);
      this.image_list.forEach((x, index) => {
        formData.append(`file`, x);
      });
      formData.append("file_no", this.showaddItem.file_no.trim());
      formData.append("regis_no", this.showaddItem.regis_no.trim());
      formData.append("tm_type", this.showaddItem.tm_type);
      formData.append("class_no", this.showaddItem.class_no.trim());
      formData.append("country", this.showaddItem.country.trim());
      // formData.append("date_of_filling", this.showaddItem.date_of_filling);
      formData.append("name_of_client", this.showaddItem.name_of_client.trim());
      if (
        this.showaddItem.date_of_regis !== "" &&
        this.showaddItem.date_of_regis !== null
      ) {
        formData.append(
          "date_of_regis",
          this.changeformatDatetoinsert(this.showaddItem.date_of_regis)
        );
      }
      formData.append("cliant_ref", this.showaddItem.cliant_ref.trim());
      formData.append("app_no", this.showaddItem.app_no.trim());
      if (
        this.showaddItem.date_of_application !== "" &&
        this.showaddItem.date_of_application !== null
      ) {
        formData.append(
          "date_of_application",
          this.changeformatDatetoinsert(this.showaddItem.date_of_application)
        );
      }
      formData.append("trademark", this.showaddItem.trademark.trim());
      formData.append("owner_contact", this.showaddItem.owner_contact);
      formData.append("agent_contact", this.showaddItem.agent_contact);
      formData.append("associate_contact", this.showaddItem.associate_contact);
      if (
        this.showaddItem.date_of_public !== "" &&
        this.showaddItem.date_of_public !== null
      ) {
        formData.append(
          "date_of_public",
          this.changeformatDatetoinsert(this.showaddItem.date_of_public)
        );
      }
      if (
        this.showaddItem.date_of_filling_appeal !== "" &&
        this.showaddItem.date_of_filling_appeal !== null
      ) {
        formData.append(
          "date_of_filling_appeal",
          this.changeformatDatetoinsert(this.showaddItem.date_of_filling_appeal)
        );
      }
      formData.append("good_service", this.showaddItem.good_service.trim());
      formData.append("val_no", this.showaddItem.val_no.trim());
      if (
        this.showaddItem.date_of_filling_lawsuit !== "" &&
        this.showaddItem.date_of_filling_lawsuit !== null
      ) {
        formData.append(
          "date_of_filling_lawsuit",
          this.changeformatDatetoinsert(
            this.showaddItem.date_of_filling_lawsuit
          )
        );
      }
      formData.append("remark", this.showaddItem.remark.trim());
      formData.append("page_no", this.showaddItem.page_no.trim());
      if (
        this.showaddItem.date_of_renewal !== "" &&
        this.showaddItem.date_of_renewal !== null
      ) {
        formData.append(
          "date_of_renewal",
          this.changeformatDatetoinsert(this.showaddItem.date_of_renewal)
        );
      }

      formData.append(
        "condition_of_regis",
        this.showaddItem.condition_of_regis.trim()
      );
      if (
        this.showaddItem.date_of_opposition !== "" &&
        this.showaddItem.date_of_opposition !== null
      ) {
        formData.append(
          "date_of_opposition",
          this.changeformatDatetoinsert(this.showaddItem.date_of_opposition)
        );
      }
      if (
        this.showaddItem.date_of_renewal_filed !== "" &&
        this.showaddItem.date_of_renewal_filed !== null
      ) {
        formData.append(
          "date_of_renewal_filed",
          this.changeformatDatetoinsert(this.showaddItem.date_of_renewal_filed)
        );
      }
      if (
        this.showaddItem.next_deadline !== "" &&
        this.showaddItem.next_deadline !== null
      ) {
        formData.append(
          "next_deadline",
          this.changeformatDatetoinsert(this.showaddItem.next_deadline)
        );
      }
      if (
        this.showaddItem.dateof_filling_affidavits !== "" &&
        this.showaddItem.dateof_filling_affidavits !== null
      ) {
        formData.append(
          "dateof_filling_affidavits",
          this.changeformatDatetoinsert(
            this.showaddItem.dateof_filling_affidavits
          )
        );
      }
      formData.append("tmstatusasoff", this.showaddItem.tmstatusasoff);
      formData.append("dip_link", this.showaddItem.dip_link.trim());
      formData.append(
        "user_create",
        Number(localStorage.getItem(server.USER_ID))
      );
      formData.append("closed", this.showaddItem.closed);
      if (
        this.showaddItem.date_of_closed !== "" &&
        this.showaddItem.date_of_closed !== null
      ) {
        formData.append(
          "date_of_closed",
          this.changeformatDatetoinsert(this.showaddItem.date_of_closed)
        );
      }
      if (
        this.showaddItem.date_of_issuing_certificate !== "" &&
        this.showaddItem.date_of_issuing_certificate !== null
      ) {
        formData.append(
          "date_of_issuing_certificate",
          this.changeformatDatetoinsert(
            this.showaddItem.date_of_issuing_certificate
          )
        );
      }
      formData.append("disclaim", this.showaddItem.disclaim);

      const resultMasterTM = await api.createMasterTMV2(formData);

      if (resultMasterTM.status == 200 || resultMasterTM.status == 201) {
        if (Number(dataAdd.tmstatusasoff) == 6) {
          await api.updateCloseApp(this.showaddItem.file_no);
        }
        var dataAdd = {
          user_id: localStorage.getItem(server.USER_ID),
          log_in_out_id: localStorage.getItem(server.LOGIN_ID),
          action: "Create",
          table_name: "mastertm",
          table_id: resultMasterTM.data.mastertm_id,
          date: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
        };

        await api.addTransectionLogCoreApi(dataAdd);

        var dataEditLog = {
          last_update: moment()
            .tz("Asia/Bangkok")
            .format("YYYY-MM-DD HH:mm:ss"),
        };

        await api.updateLogInOutLog(
          localStorage.getItem(server.LOGIN_ID),
          dataEditLog
        );

        this.$hideLoader();
        this.dialogAddmastertm = false;
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "save data",
          "save data success",
          "text-h5 green--text text-center",
          `/appointmenttm-add/${resultMasterTM.data.file_no}/${this.date_of_renewal}`
        );
        return;
      } else if (resultMasterTM.status == 204) {
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "data duplicate ",
          "please check File No. and Application No.",
          "text-h5 red--text text-center"
        );
        return;
      } else {
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "save data",
          "can't save data",
          "text-h5 red--text text-center"
        );
        return;
      }
    },

    async loaddataobjecttypeBygroupId() {
      const result = await api.getObjectTypeByGroupId(1);

      this.objecttype_list = result.data;
      // const result = await api.getAllMasterTM();
      // this.mDataArray = result.data;
    },
    async loaddatacontactByContact_type_owner() {
      const result = await api.getContactByContactType(1);
      this.contact_owner_list = result.data;
      // const result = await api.getAllMasterTM();
      // this.mDataArray = result.data;
    },
    async loaddatacontactByContact_type_agent() {
      const result = await api.getContactByContactType(2);
      this.contact_agent_list = result.data;
      // const result = await api.getAllMasterTM();
      // this.mDataArray = result.data;
    },
    async loaddatacontactByContact_type_associate() {
      const result = await api.getContactByContactType(3);
      this.contact_associate_list = result.data;
      // const result = await api.getAllMasterTM();
      // this.mDataArray = result.data;
    },
    async loaddatacountry() {
      const result = await api.getAllCountry();
      this.country_list = result.data;
    },
    async loaddatatmupdatestatus() {
      const result = await api.getAlltmupdatestatus();
      this.tmstatus_list = result.data;
    },

    async onSelectOwnerChange() {
      if (this.owner_contact_list.length > 0) {
        for (const [index, item] of this.owner_contact_list.entries()) {
          item.owner_address =
            item.address + " " + item.city + " " + item.country;
        }
      }
    },
    async onSelectCountryChange(name) { },
    async onSelectAgentChange(id) {
      let setdata;
      setdata = this.contact_agent_list.filter((item) => {
        if (item.contact_id == id) {
          this.showaddItem.agent_email = item.email;
          this.showaddItem.agent_address =
            item.address + " " + item.city + " " + item.country;
          return item;
        }
      });
    },
    async onSelectAssociateChange(id) {
      let setdata;
      setdata = this.contact_associate_list.filter((item) => {
        if (item.contact_id == id) {
          this.showaddItem.associate_address =
            item.address + " " + item.city + " " + item.country;
          return item;
        }
      });
    },
    async onSelectObjiTypeChange() {
      if (this.showaddItem.tm_type == 0) return;
      const selectedItem = this.objecttype_list.find(
        (item) => item.objecttype_id === this.showaddItem.tm_type
      );

      this.setDefluatData();

      this.showFiling = false;
      this.showIsSearch = false;
      this.showTrademarkOhter = false;
      this.showTrademarkInfringementPoliceCustoms = false;

      this.showaddItem.file_no = "";

      if (this.showaddItem.tm_type == 1 || this.showaddItem.tm_type == 3) {
        this.showFiling = true;
      } else {
        var objecttype_name = selectedItem.objecttype_code;

        if (this.showaddItem.tm_type == 6 || this.showaddItem.tm_type == 10) {
          this.showIsSearch = true;
          if (objecttype_id == 10) {
            this.decisionBoxes = [];
            this.decisionBoxes.push({
              id: 0,
              files: [],
              date: "",
              menuReceiveBox: false,
              result: "",
              level: 1,
            });
            this.labels = [
              "อัปโหลดไฟล์คำวินิจฉัยของนายทะเบียน",
              "อัปโหลดไฟล์คำวินิจฉัยของชั้นคณะกรรมการ",
              "อัปโหลดไฟล์คำวินิจฉัยไปศาล",
            ];
            this.labelsDecripnt = [
              "วันที่รับคำวินิจฉัยของนายทะเบียน",
              "วันที่รับคำวินิจฉัยของชั้นคณะกรรมการ",
              "วันที่รับคำวินิจฉัยไปศาล",
            ];
          }
        } else if (
          this.showaddItem.tm_type == 7 ||
          this.showaddItem.tm_type == 11
        ) {
          this.decisionBoxes = [];
          this.decisionBoxes.push({
            id: 0,
            files: [],
            date: "",
            menuReceiveBox: false,
            result: "",
            level: 1,
          });

          this.labels = [
            "อัปโหลดไฟล์คำวินิจฉัยของนายทะเบียน",
            "อัปโหลดไฟล์คำวินิจฉัยของชั้นคณะกรรมการ",
            "อัปโหลดไฟล์คำวินิจฉัยไปศาล",
          ];
          this.labelsDecripnt = [
            "วันที่รับคำวินิจฉัยของนายทะเบียน",
            "วันที่รับคำวินิจฉัยของชั้นคณะกรรมการ",
            "วันที่รับคำวินิจฉัยไปศาล",
          ];
        } else if (this.showaddItem.tm_type == 8) {
          this.decisionBoxes = [];
          this.decisionBoxes.push({
            id: 0,
            files: [],
            date: "",
            menuReceiveBox: false,
            result: "",
            level: 1,
          });

          this.labels = [
            "อัปโหลดไฟล์คำวินิจฉัยของชั้นคณะกรรมการ",
            "อัปโหลดไฟล์คำวินิจฉัยไปศาล",
          ];
          this.labelsDecripnt = [
            "วันที่รับคำวินิจฉัยของชั้นคณะกรรมการ",
            "วันที่รับคำวินิจฉัยไปศาล",
          ];
        } else if (this.showaddItem.tm_type == 9) {
          this.showTrademarkInfringementPoliceCustoms = true;
          objecttype_name = "Trademark Infringement Police Customs";
        }

        const res_mode = await api.fineDocRunningByModlue(
          objecttype_name,
          Number(localStorage.getItem(server.COMPANYID))
        );

        if (res_mode.status == 200 && res_mode.data) {
          const { id_prefix, running_year, running_next, running_len } =
            res_mode.data;
          const runningStr = String(running_next).padStart(running_len, "0");
          const docrunning = `${id_prefix}${running_year}${runningStr}`;
          this.showaddItem.file_no = docrunning;
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "No data File No. Please contact the system administrator.",
            "text-h5 red--text text-center"
          );
          return;
        }
      }
    },
    async onSelectCustomerChange() { },

    async popupdeletefile(index) {
      this.fileindex = index;
      this.dialogDelete = true;
    },
    async popupdeletefile_cer(index_cer) {
      this.fileindex_cer = index_cer;
      this.dialogDelete_cer = true;
    },
    async closeDelete() {
      this.fileindex = -1;
      this.dialogDelete = false;
    },
    async closeDelete_cer() {
      this.fileindex = -1;
      this.dialogDelete_cer = false;
    },
    async deleteItemConfirm() {
      let dataDel = this.image_list[this.fileindex];
      if (dataDel.isOld) {
        this.removeFillingFile.push(dataDel);
      }
      this.image_list.splice(this.fileindex, 1);
      this.filename.splice(this.fileindex, 1);

      this.fileindex = -1;
      this.dialogDelete = false;
    },
    async deleteItemConfirm_cer() {
      let dataDel = this.image_list_cer[this.fileindex_cer];
      if (dataDel.isOld) {
        this.removeFillingCer.push(dataDel);
      }
      this.image_list_cer.splice(this.fileindex_cer, 1);
      this.filename_cer.splice(this.fileindex_cer, 1); // เปลี่ยนเป็น _cer
      this.fileindex_cer = -1;
      this.dialogDelete_cer = false;
    },
    async popupdeleteimage(index) {
      this.indexDelImage = index;
      this.dialogDeleteimage = true;
    },
    async popupdeleteimageOpposition(index) {
      this.indexDelImageOpposition = index;
      this.dialogDeleteimageOpposition = true;
    },
    async closeDeleteimage() {
      this.dialogDeleteimage = false;
    },
    async deleteItemConfirmimage() {
      let dataDel = this.images[this.indexDelImage];
      if (dataDel.isOld) {
        this.removeTMimageFile.push(dataDel);
      }
      this.images.splice(this.indexDelImage, 1);
      this.imagenames.splice(this.indexDelImage, 1);
      this.previews.splice(this.indexDelImage, 1);

      if (this.imagenames.length === 0) {
        this.checkimageadd = false;
      }
      this.dialogDeleteimage = false;
    },
    async popuppreviewfile(fileindex) {
      const checkfile = this.image_list[fileindex];

      // ✅ ถ้าเป็นไฟล์เก่า (isOld)
      if (checkfile.isOld) {
        // --- PDF ---
        if (
          checkfile.type === "file" ||
          checkfile.name.toLowerCase().endsWith(".pdf")
        ) {
          const fileUrl = `${filemasterTMUrl}/${this.$route.params.mastertm_id}/${checkfile.name}`;
          const newTab = window.open("");
          newTab.document.write(`
        <html>
          <head>
            <title>PDF Preview</title>
            <style>
              html, body { margin:0; height:100%; overflow:hidden; }
              iframe { border:none; width:100%; height:100%; }
            </style>
          </head>
          <body>
            <iframe src="${fileUrl}" title="PDF Preview"></iframe>
          </body>
        </html>
      `);
          newTab.document.close();
          return;
        }

        // --- Word ---
        if (
          checkfile.name.toLowerCase().endsWith(".doc") ||
          checkfile.name.toLowerCase().endsWith(".docx")
        ) {
          const fileUrl = `${filemasterTMUrl}/${this.$route.params.mastertm_id}/${checkfile.name}`;
          const link = document.createElement("a");
          link.href = fileUrl;
          link.download = checkfile.name;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          return;
        }

        // --- Image ---
        const imageUrl = `${imagemasterTMUrl}/${this.$route.params.mastertm_id}/${checkfile.name}`;
        const newTab = window.open("");
        newTab.document.write(`
      <html>
        <head>
          <title>Image Preview</title>
          <style>
            html, body {
              margin:0;
              height:100%;
              overflow:hidden;
              background-color:black;
              display:flex;
              justify-content:center;
              align-items:center;
            }
            img { max-width:100%; max-height:100%; object-fit:contain; }
          </style>
        </head>
        <body>
          <img src="${imageUrl}" alt="Image Preview" />
        </body>
      </html>
    `);
        newTab.document.close();
        return;
      }

      // ✅ ถ้าเป็นไฟล์ใหม่ (อัปโหลดในรอบนี้)
      if (checkfile.type === "application/pdf") {
        // --- PDF Preview ---
        const reader = new FileReader();
        reader.onload = (e) => {
          const fileData = e.target.result;
          const pdf_newTab = window.open("");
          pdf_newTab.document.write(`
        <html>
          <head>
            <title>PDF Preview</title>
            <style>
              html, body { margin:0; height:100%; overflow:hidden; }
              iframe { border:none; width:100%; height:100%; }
            </style>
          </head>
          <body>
            <iframe src="${fileData}" title="PDF Preview"></iframe>
          </body>
        </html>
      `);
          pdf_newTab.document.close();
        };
        reader.readAsDataURL(checkfile);
      } else if (
        checkfile.type === "application/msword" ||
        checkfile.type ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        // --- Word File → Download ---
        const url = URL.createObjectURL(checkfile);
        const link = document.createElement("a");
        link.href = url;
        link.download = checkfile.name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } else {
        // --- Image Preview ---
        const reader = new FileReader();
        reader.onload = (e) => {
          const fileData = e.target.result;
          const image_newTab = window.open("");
          image_newTab.document.write(`
        <html>
          <head>
            <title>Image Preview</title>
            <style>
              html, body {
                margin:50px 0 0 0;
                height:80%;
                overflow:hidden;
                background-color:black;
                display:flex;
                justify-content:center;
                align-items:center;
              }
              img { width:100%; height:100%; object-fit:contain; }
            </style>
          </head>
          <body>
            <img src="${fileData}" title="Image Preview" />
          </body>
        </html>
      `);
          image_newTab.document.close();
        };
        reader.readAsDataURL(checkfile);
      }
    },
    async popuppreviewfile_cer(fileindex_cer) {
      const checkfile = this.image_list_cer[fileindex_cer];

      // ✅ ถ้าเป็นไฟล์เก่า
      if (checkfile.isOld) {
        // --- PDF ---
        if (
          checkfile.type === "file" ||
          checkfile.name.toLowerCase().endsWith(".pdf")
        ) {
          let fileUrl = `${filemasterTMUrl}/${this.$route.params.mastertm_id}/${checkfile.name}`;
          const newTab = window.open("");
          newTab.document.write(`
        <html>
          <head>
            <title>PDF Preview</title>
            <style>
              html, body { margin:0; height:100%; overflow:hidden; }
              iframe { border:none; width:100%; height:100%; }
            </style>
          </head>
          <body>
            <iframe src="${fileUrl}" title="PDF Preview"></iframe>
          </body>
        </html>
      `);
          newTab.document.close();
          return;
        }

        // --- Word ---
        if (
          checkfile.name.toLowerCase().endsWith(".doc") ||
          checkfile.name.toLowerCase().endsWith(".docx")
        ) {
          let fileUrl = `${filemasterTMUrl}/${this.$route.params.mastertm_id}/${checkfile.name}`;
          const link = document.createElement("a");
          link.href = fileUrl;
          link.download = checkfile.name;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          return;
        }

        // --- Image ---
        let fileUrl = `${imagemasterTMUrl}/${this.$route.params.mastertm_id}/${checkfile.name}`;
        const imageTab = window.open("");
        imageTab.document.write(`
      <html>
        <head>
          <title>Image Preview</title>
          <style>
            html, body {
              margin:0;
              height:100%;
              overflow:hidden;
              background-color:black;
              display:flex;
              justify-content:center;
              align-items:center;
            }
            img { max-width:100%; max-height:100%; object-fit:contain; }
          </style>
        </head>
        <body>
          <img src="${fileUrl}" alt="Image Preview" />
        </body>
      </html>
    `);
        imageTab.document.close();
        return;
      }

      // ✅ ถ้าเป็นไฟล์ใหม่ (upload รอบนี้)
      if (checkfile.type === "application/pdf") {
        const reader = new FileReader();
        reader.onload = (e) => {
          const fileData = e.target.result;
          const pdf_newTab = window.open("");
          pdf_newTab.document.write(`
        <html>
          <head>
            <title>PDF Preview</title>
            <style>
              html, body { margin:0; height:100%; overflow:hidden; }
              iframe { border:none; width:100%; height:100%; }
            </style>
          </head>
          <body>
            <iframe src="${fileData}" title="PDF Preview"></iframe>
          </body>
        </html>
      `);
          pdf_newTab.document.close();
        };
        reader.readAsDataURL(checkfile);
      } else if (
        checkfile.type === "application/msword" ||
        checkfile.type ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        // --- Word File → Download ---
        const url = URL.createObjectURL(checkfile);
        const link = document.createElement("a");
        link.href = url;
        link.download = checkfile.name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } else {
        // --- Image Preview ---
        const reader = new FileReader();
        reader.onload = (e) => {
          const fileData = e.target.result;
          const image_newTab = window.open("");
          image_newTab.document.write(`
        <html>
          <head>
            <title>Image Preview</title>
            <style>
              html, body {
                margin:0;
                height:100%;
                overflow:hidden;
                background-color:black;
                display:flex;
                justify-content:center;
                align-items:center;
              }
              img { max-width:100%; max-height:100%; object-fit:contain; }
            </style>
          </head>
          <body>
            <img src="${fileData}" alt="Image Preview" />
          </body>
        </html>
      `);
          image_newTab.document.close();
        };
        reader.readAsDataURL(checkfile);
      }
    },
    async closepreviewfile() {
      this.dialogpreviewfile = false;
    },
    popuppreviewimage(index) {
      const imageTab = window.open("");
      imageTab.document.write(`
    <html>
      <head>
        <title>Preview Image</title>
        <style>
          body {
            margin: 0;
            background-color: #000;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh;
          }
          .toolbar {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 50px;
            background: rgba(20, 20, 20, 0.9);
            display: flex;
            justify-content: flex-end;
            align-items: center;
            padding: 0 20px;
            box-sizing: border-box;
            z-index: 10;
            backdrop-filter: blur(6px); /* เบลอพื้นหลัง */
          }
          .icon-btn {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background: rgba(255,255,255,0.1);
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.3s ease;
          }
          .icon-btn:hover {
            background: rgba(255,255,255,0.25);
            transform: scale(1.1);
          }
          .icon-btn svg {
            width: 22px;
            height: 22px;
            fill: #fff;
          }
          img {
            max-width: 100%;
            max-height: 100%;
          }
        </style>
      </head>
      <body>
        <div class="toolbar">
          <a href="${this.previews[index]}" download="image_${index}.jpg" class="icon-btn" title="ดาวน์โหลด">
            <!-- SVG ไอคอนดาวน์โหลด -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M5 20h14v-2H5v2zm7-18v12l4-4h-3V4h-2v6H8l4 4z"/>
            </svg>
          </a>
        </div>
        <img src="${this.previews[index]}" alt="Preview" />
      </body>
    </html>
  `);
      return;
    },
    popuppreviewimageOpposed(index) {
      const imageTab = window.open("");
      imageTab.document.write(`
    <html>
      <head>
        <title>Preview Image</title>
        <style>
          body {
            margin: 0;
            background-color: #000;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh;
          }
          .toolbar {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 50px;
            background: rgba(20, 20, 20, 0.9);
            display: flex;
            justify-content: flex-end;
            align-items: center;
            padding: 0 20px;
            box-sizing: border-box;
            z-index: 10;
            backdrop-filter: blur(6px);
          }
          .icon-btn {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background: rgba(255,255,255,0.1);
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.3s ease;
          }
          .icon-btn:hover {
            background: rgba(255,255,255,0.25);
            transform: scale(1.1);
          }
          .icon-btn svg {
            width: 22px;
            height: 22px;
            fill: #fff;
          }
          img {
            max-width: 100%;
            max-height: 100%;
          }
        </style>
      </head>
      <body>
        <div class="toolbar">
          <a href="${this.previewsOpposed[index]}"
             download="${this.imagenamesOpposed[index] || "image_" + index}.jpg"
             class="icon-btn"
             title="ดาวน์โหลด">
            <!-- SVG ไอคอนดาวน์โหลด -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M5 20h14v-2H5v2zm7-18v12l4-4h-3V4h-2v6H8l4 4z"/>
            </svg>
          </a>
        </div>
        <img src="${this.previewsOpposed[index]}" alt="Preview" />
      </body>
    </html>
  `);
      return;
    },

    async closepreviewimage() {
      this.dialogpreviewimage = false;
    },
    async openhideshowtimeline() {
      this.disablebtnappointmenttimeline = !this.disablebtnappointmenttimeline;
    },
    // getUniqueFileNameImage(fileName, existingNames = []) {
    //   // แปลงชื่อไฟล์ให้ปลอดภัย
    //   let baseName = fileName.replace(/[^a-zA-Z0-9._\-ก-๙]/g, "_");
    //   let finalName = baseName;
    //   let counter = 1;

    //   while (existingNames.includes(finalName)) {
    //     const dotIndex = baseName.lastIndexOf(".");
    //     if (dotIndex !== -1) {
    //       const name = baseName.substring(0, dotIndex);
    //       const ext = baseName.substring(dotIndex);
    //       finalName = `${name}-${counter}${ext}`;
    //     } else {
    //       finalName = `${baseName}-${counter}`;
    //     }
    //     counter++;
    //   }

    //   return finalName;
    // },

    // // ฟังก์ชันอัปโหลดและ resize รูป
    // previewImage(event) {
    //   const files = event.target.files;
    //   if (!files.length) return;

    //   for (let i = 0; i < files.length; i++) {
    //     const file = files[i];

    //     if (!file.type.startsWith("image/")) {
    //       alert("กรุณาเลือกไฟล์รูปภาพเท่านั้น");
    //       continue;
    //     }

    //     // ใช้ฟังก์ชันตรวจสอบชื่อไฟล์ซ้ำ
    //     const safeName = this.getUniqueFileNameImage(
    //       file.name,
    //       this.imagenames
    //     );

    //     // เก็บไฟล์
    //     this.images.push(file);
    //     this.imagenames.push(safeName);

    //     // อ่านไฟล์แล้ว resize
    //     const reader = new FileReader();
    //     reader.onload = (e) => {
    //       const img = new Image();
    //       img.onload = () => {
    //         const canvas = document.createElement("canvas");
    //         const ctx = canvas.getContext("2d");

    //         const maxSize = 592;
    //         let width = img.width;
    //         let height = img.height;

    //         // คำนวณอัตราส่วน
    //         if (width > height) {
    //           if (width > maxSize) {
    //             height = Math.round((height * maxSize) / width);
    //             width = maxSize;
    //           }
    //         } else {
    //           if (height > maxSize) {
    //             width = Math.round((width * maxSize) / height);
    //             height = maxSize;
    //           }
    //         }

    //         canvas.width = width;
    //         canvas.height = height;

    //         ctx.drawImage(img, 0, 0, width, height);

    //         const resizedDataUrl = canvas.toDataURL("image/jpeg", 0.9);
    //         this.previews.push(resizedDataUrl);
    //       };
    //       img.src = e.target.result;
    //     };
    //     reader.readAsDataURL(file);
    //   }

    //   this.checkimageadd = true;

    //   // รีเซต input เพื่อให้เลือกไฟล์ชื่อเดิมอีกครั้งได้
    //   event.target.value = null;
    // },
    // generateUniqueFileName(originalName) {
    //   // sanitize ก่อน (แทนทุกตัวที่ไม่ใช่ a-z, A-Z, 0-9, ., _, -, ก-๙ → _)
    //   let sanitizedName = originalName.replace(/[^a-zA-Z0-9._\-ก-๙]/g, "_");

    //   let newName = sanitizedName;
    //   let nameIndex = 1;
    //   const allNames = [...this.filename, ...this.filename_cer]; // เช็ครวมกันทั้ง main และ cer

    //   while (allNames.includes(newName)) {
    //     const dotIndex = sanitizedName.lastIndexOf(".");
    //     if (dotIndex !== -1) {
    //       // ถ้ามี .นามสกุลไฟล์ → แทรก -1, -2, ...
    //       newName = `${sanitizedName.substring(
    //         0,
    //         dotIndex
    //       )}-${nameIndex}${sanitizedName.substring(dotIndex)}`;
    //     } else {
    //       // ถ้าไม่มีนามสกุล
    //       newName = `${sanitizedName}-${nameIndex}`;
    //     }
    //     nameIndex++;
    //   }

    //   return newName;
    // },

    // async previewMultiImage(event) {
    //   const input = event.target;
    //   if (!input.files) return;

    //   for (let i = 0; i < input.files.length; i++) {
    //     const originalFile = input.files[i];
    //     if (originalFile.type !== "application/pdf") continue;

    //     // สร้างชื่อไฟล์ไม่ซ้ำ
    //     const newName = this.generateUniqueFileName(originalFile.name);

    //     // Clone ไฟล์พร้อมชื่อใหม่
    //     const renamedFile = new File([originalFile], newName, {
    //       type: originalFile.type,
    //     });
    //     this.image_list.push(renamedFile);
    //     this.filename.push(newName);

    //     // อ่าน preview
    //     const result = await new Promise((resolve) => {
    //       const reader = new FileReader();
    //       reader.onload = (e) => resolve(e.target.result);
    //       reader.readAsDataURL(renamedFile);
    //     });

    //     this.getpreview_list.push(result);
    //     this.preview_list.push(result);
    //   }

    //   this.preview_list2 = this.preview_list;
    //   this.checkfileeadd = true;
    //   event.target.value = null;
    // },
    // async previewMultiImage_cer(event) {
    //   const input_cer = event.target;
    //   if (!input_cer.files) return;

    //   for (let i = 0; i < input_cer.files.length; i++) {
    //     const originalFile_cer = input_cer.files[i];
    //     if (originalFile_cer.type !== "application/pdf") continue;

    //     const newName_cer = this.generateUniqueFileName(originalFile_cer.name);

    //     const renamedFile_cer = new File([originalFile_cer], newName_cer, {
    //       type: originalFile_cer.type,
    //     });
    //     this.image_list_cer.push(renamedFile_cer);
    //     this.filename_cer.push(newName_cer);

    //     const result = await new Promise((resolve) => {
    //       const reader = new FileReader();
    //       reader.onload = (e) => resolve(e.target.result);
    //       reader.readAsDataURL(renamedFile_cer);
    //     });

    //     this.getpreview_list_cer.push(result);
    //     this.preview_list_cer.push(result);
    //   }

    //   this.preview_list2_cer = this.preview_list_cer;
    //   this.checkfileeadd_cer = true;
    //   event.target.value = null;
    // },
    // reset: function () {
    //   this.image = null;
    //   this.previewimage = null;
    //   this.image_list = [];
    //   this.preview_list = [];
    // },
    async getPdfforpreview(datafile) {
      this.previewpopupfile = [];
      let getfile = [];
      getfile = datafile;
      this.previewpopupfile.push(pdfvuer.createLoadingTask(`${getfile}`));
      this.previewpopupfile.forEach((item, index) => {
        item.then((pdf) => {
          this.numPagespreview = pdf.numPages;
        });
      });
    },
    async getPdfforAdd(item) {
      this.preview_list = [];
      let getfile = [];
      getfile = item;
      getfile.forEach((file, index) => {
        this.preview_list.push(pdfvuer.createLoadingTask(`${file}`));
      });
      this.preview_list.forEach((item, index) => {
        item.then((pdf) => {
          this.numPages = pdf.numPages;
          // window.onscroll = function() {
          //   changePage();
          //   stickyNav();
          // };
          // Get the offset position of the navbar
          // var sticky = $("#buttons")[0].offsetTop;
          // // Add the sticky class to the this.$refs.nav when you reach its scroll position. Remove "sticky" when you leave the scroll position
          // function stickyNav() {
          //   if (window.pageYOffset >= sticky) {
          //     $("#buttons")[0].classList.remove("hidden");
          //   } else {
          //     $("#buttons")[0].classList.add("hidden");
          //   }
          // }
          function changePage() {
            var i = 1,
              count = Number(pdf.numPages);
            do {
              if (
                window.pageYOffset >=
                this.findPos(document.getElementById(i)) &&
                window.pageYOffset <=
                this.findPos(document.getElementById(i + 1))
              ) {
                this.page = i;
              }
              i++;
            } while (i < count);
            if (
              window.pageYOffset >= this.findPos(document.getElementById(i))
            ) {
              this.page = i;
            }
          }
        });
      });
      this.checkfileadd = true;
    },
    async getPdfforAdd_cer(item_cer) {
      this.preview_list_cer = [];
      let getfile_cer = [];
      getfile_cer = item_cer;

      getfile_cer.forEach((file_cer, index_cer) => {
        this.preview_list_cer.push(pdfvuer.createLoadingTask(`${file_cer}`));
      });

      this.preview_list_cer.forEach((item_cer, index_cer) => {
        item_cer.then((pdf_cer) => {
          this.numPages_cer = pdf_cer.numPages;

          function changePage_cer() {
            var i_cer = 1,
              count_cer = Number(pdf_cer.numPages);
            do {
              if (
                window.pageYOffset >=
                this.findPos(document.getElementById(i_cer)) &&
                window.pageYOffset <=
                this.findPos(document.getElementById(i_cer + 1))
              ) {
                this.page_cer = i_cer;
              }
              i_cer++;
            } while (i_cer < count_cer);

            if (
              window.pageYOffset >= this.findPos(document.getElementById(i_cer))
            ) {
              this.page_cer = i_cer;
            }
          }
        });
      });

      this.checkfileadd_cer = true;
    },
    handle_pdf_link: function (params) {
      // Scroll to the appropriate place on our page - the Y component of
      // params.destArray * (div height / ???), from the bottom of the page div
      var page = document.getElementById(String(params.pageNumber));
      page.scrollIntoView();
    },
    findPos(obj) {
      return obj.offsetTop;
    },
    async CalculateNewRenewalDate() {
      let addyear = 10;
      let addday = 1;

      if (
        this.showaddItem.date_of_renewal &&
        this.showaddItem.date_of_renewal != ""
      ) {
        addday = 0;
        this.date_of_renewal = new Date(
          new Date(this.date_of_renewal).setFullYear(
            new Date(this.date_of_renewal).getFullYear() + addyear,
            new Date(this.date_of_renewal).getMonth(),
            new Date(this.date_of_renewal).getDate() - addday
          ) -
          new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10);
        this.showaddItem.date_of_renewal = this.formatDate(
          this.date_of_renewal
        );
        this.disableCalculateNewRenewalDate = true;
      } else {
        if (
          !this.showaddItem.date_of_application ||
          this.showaddItem.date_of_application == ""
        ) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please enter Application Date Data",
            "text-h5 red--text text-center"
          );
          return;
        }
        this.date_of_renewal = new Date(
          new Date(this.date_of_application).setFullYear(
            new Date(this.date_of_application).getFullYear() + addyear,
            new Date(this.date_of_application).getMonth(),
            new Date(this.date_of_application).getDate() - addday
          ) -
          new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10);
        this.showaddItem.date_of_renewal = this.formatDate(
          this.date_of_renewal
        );
        this.disableCalculateNewRenewalDate = true;
      }
    },
    async Selectchangedate_of_application() {
      // this.disableCalculateNewRenewalDate = false;
    },

    changeformatDatetoinsert(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("/");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
    },
    // formatDate(date) {
    //   if (!date) return null;

    //   const [year, month, day] = date.split("-");
    //   return `${year}/${month}/${day}`;
    // },
    // parseDate(date) {
    //   if (!date) return null;

    //   const [year, month, day] = date.split("/");
    //   return `${year}/${month.padStart(2, "0")}/${day.padStart(2, "0")}`;
    // },
    async setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    async setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    async previewnoticefilepdf(index) {
      const checkfile = this.image_listnotice[index];

      // ถ้าเป็นไฟล์เก่า
      if (checkfile.isOld) {
        // --- PDF ---
        if (
          checkfile.type === "file" ||
          checkfile.name.toLowerCase().endsWith(".pdf")
        ) {
          let fileUrl = `${filemasterTMUrl}/${this.$route.params.mastertm_id}/${checkfile.name}`;
          const newTab = window.open("");
          newTab.document.write(`
        <html>
          <head>
            <title>PDF Preview</title>
            <style>
              html, body { margin:0; height:100%; overflow:hidden; }
              iframe { border:none; width:100%; height:100%; }
            </style>
          </head>
          <body>
            <iframe src="${fileUrl}" title="PDF Preview"></iframe>
          </body>
        </html>
      `);
          newTab.document.close();
          return;
        }

        // --- Word ---
        if (
          checkfile.name.toLowerCase().endsWith(".doc") ||
          checkfile.name.toLowerCase().endsWith(".docx")
        ) {
          let fileUrl = `${filemasterTMUrl}/${this.$route.params.mastertm_id}/${checkfile.name}`;
          const link = document.createElement("a");
          link.href = fileUrl;
          link.download = checkfile.name;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          return;
        }

        // --- Image ---
        let fileUrl = `${imagemasterTMUrl}/${this.$route.params.mastertm_id}/${checkfile.name}`;
        const newTab = window.open("");
        newTab.document.write(`
      <html>
        <head>
          <title>Image Preview</title>
          <style>
            html, body {
              margin:0;
              height:100%;
              overflow:hidden;
              background-color:black;
              display:flex;
              justify-content:center;
              align-items:center;
            }
            img { max-width:100%; max-height:100%; object-fit:contain; }
          </style>
        </head>
        <body>
          <img src="${fileUrl}" alt="Image Preview" />
        </body>
      </html>
    `);
        newTab.document.close();
        return;
      }

      // ถ้าเป็นไฟล์ใหม่ (อัปโหลดในรอบนี้)
      if (checkfile.type === "application/pdf") {
        // --- PDF Preview ---
        const reader = new FileReader();
        reader.onload = (e) => {
          const fileData = e.target.result;
          const pdf_newTab = window.open("");
          pdf_newTab.document.write(`
        <html>
          <head>
            <title>PDF Preview</title>
            <style>
              html, body { margin:0; height:100%; overflow:hidden; }
              iframe { border:none; width:100%; height:100%; }
            </style>
          </head>
          <body>
            <iframe src="${fileData}" title="PDF Preview"></iframe>
          </body>
        </html>
      `);
          pdf_newTab.document.close();
        };
        reader.readAsDataURL(checkfile);
      } else if (
        checkfile.type === "application/msword" ||
        checkfile.type ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        // --- Word File → Download ---
        const url = URL.createObjectURL(checkfile);
        const link = document.createElement("a");
        link.href = url;
        link.download = checkfile.name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } else {
        // --- Image Preview ---
        const reader = new FileReader();
        reader.onload = (e) => {
          const fileData = e.target.result;
          const image_newTab = window.open("");
          image_newTab.document.write(`
        <html>
          <head>
            <title>Image Preview</title>
            <style>
              html, body {
                margin:50px 0 0 0;
                height:80%;
                overflow:hidden;
                background-color:black;
                display:flex;
                justify-content:center;
                align-items:center;
              }
              img { width:100%; height:100%; object-fit:contain; }
            </style>
          </head>
          <body>
            <img src="${fileData}" title="Image Preview" />
          </body>
        </html>
      `);
          image_newTab.document.close();
        };
        reader.readAsDataURL(checkfile);
      }
    },
    async previewattachfile(index) {
      const checkfile = this.image_listattach[index];
      const fileName = this.filenameattach[index];

      // ถ้าเป็นไฟล์เก่า
      if (checkfile.isOld) {
        // --- PDF ---
        if (
          checkfile.type === "file" ||
          fileName.toLowerCase().endsWith(".pdf")
        ) {
          let fileUrl = `${filemasterTMUrl}/${this.$route.params.mastertm_id}/${fileName}`;
          const newTab = window.open("");
          newTab.document.write(`
        <html>
          <head>
            <title>PDF Preview</title>
            <style>
              html, body { margin:0; height:100%; overflow:hidden; }
              iframe { border:none; width:100%; height:100%; }
            </style>
          </head>
          <body>
            <iframe src="${fileUrl}" title="PDF Preview"></iframe>
          </body>
        </html>
      `);
          newTab.document.close();
          return;
        }

        // --- Word ---
        if (
          fileName.toLowerCase().endsWith(".doc") ||
          fileName.toLowerCase().endsWith(".docx")
        ) {
          let fileUrl = `${filemasterTMUrl}/${this.$route.params.mastertm_id}/${fileName}`;
          const link = document.createElement("a");
          link.href = fileUrl;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          return;
        }

        // --- Image ---
        let fileUrl = `${imagemasterTMUrl}/${this.$route.params.mastertm_id}/${fileName}`;
        const newTab = window.open("");
        newTab.document.write(`
      <html>
        <head>
          <title>Image Preview</title>
          <style>
            html, body {
              margin:0;
              height:100%;
              overflow:hidden;
              background-color:black;
              display:flex;
              justify-content:center;
              align-items:center;
            }
            img { max-width:100%; max-height:100%; object-fit:contain; }
          </style>
        </head>
        <body>
          <img src="${fileUrl}" alt="Image Preview" />
        </body>
      </html>
    `);
        newTab.document.close();
        return;
      }

      // ถ้าเป็นไฟล์ใหม่ (อัปโหลดในรอบนี้)
      if (checkfile.type === "application/pdf") {
        // --- PDF Preview ---
        const reader = new FileReader();
        reader.onload = (e) => {
          const fileData = e.target.result;
          const pdf_newTab = window.open("");
          pdf_newTab.document.write(`
        <html>
          <head>
            <title>PDF Preview</title>
            <style>
              html, body { margin:0; height:100%; overflow:hidden; }
              iframe { border:none; width:100%; height:100%; }
            </style>
          </head>
          <body>
            <iframe src="${fileData}" title="PDF Preview"></iframe>
          </body>
        </html>
      `);
          pdf_newTab.document.close();
        };
        reader.readAsDataURL(checkfile);
      } else if (
        checkfile.type === "application/msword" ||
        checkfile.type ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        // --- Word File → Download ---
        const url = URL.createObjectURL(checkfile);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } else {
        // --- Image Preview ---
        const reader = new FileReader();
        reader.onload = (e) => {
          const fileData = e.target.result;
          const image_newTab = window.open("");
          image_newTab.document.write(`
        <html>
          <head>
            <title>Image Preview</title>
            <style>
              html, body {
                margin:50px 0 0 0;
                height:80%;
                overflow:hidden;
                background-color:black;
                display:flex;
                justify-content:center;
                align-items:center;
              }
              img { width:100%; height:100%; object-fit:contain; }
            </style>
          </head>
          <body>
            <img src="${fileData}" title="Image Preview" />
          </body>
        </html>
      `);
          image_newTab.document.close();
        };
        reader.readAsDataURL(checkfile);
      }
    },
    async confirmdeletenoticefile(index) {
      this.indexdeleteattachfilelist = index;
      this.dialogconfirmdeletenoticefile = true;
    },
    async closedialogconfirmdeletenoticefile() {
      this.dialogconfirmdeletenoticefile = false;
    },
    async deletedialogconfirmdeletenoticefile() {
      let dataDel = this.image_listnotice[this.indexdeleteattachfilelist];
      if (dataDel.isOld) {
        this.removeNoticFile.push(dataDel);
      }

      this.image_listnotice.splice(this.indexdeleteattachfilelist, 1);
      this.filenamenotice.splice(this.indexdeleteattachfilelist, 1);
      this.dialogconfirmdeletenoticefile = false;
    },
    async confirmdeleteattachfile(index) {
      this.indexdeleteattachfile = index;
      this.dialogconfirmdeleteattachfile = true;
    },
    async closedialogconfirmdeleteattachfile() {
      this.indexdeleteattachfile = -1;
      this.dialogconfirmdeleteattachfile = false;
    },
    async deletedialogconfirmdeleteattachfile() {
      let dataDel = this.image_listattach[this.indexdeleteattachfile];
      if (dataDel.isOld) {
        this.removeAttactFile.push(dataDel);
      }
      this.filenameattach.splice(this.indexdeleteattachfile, 1);
      this.image_listattach.splice(this.indexdeleteattachfile, 1);
      this.dialogconfirmdeleteattachfile = false;
    },
    sanitizeFileName(fileName) {
      const dotIndex = fileName.lastIndexOf(".");
      const baseName =
        dotIndex !== -1 ? fileName.substring(0, dotIndex) : fileName;
      const extension = dotIndex !== -1 ? fileName.substring(dotIndex) : "";

      const sanitizedBase = baseName.replace(/[^a-zA-Z0-9-_ก-ฮะ-์]/g, "_");
      return sanitizedBase + extension;
    },

    // --- ฟังก์ชันตรวจสอบชื่อซ้ำและต่อเลข ---
    getUniqueFileName(file) {
      let name = this.sanitizeFileName(file.name);
      let base = name;
      let counter = 1;

      while (this.dataFileAll.includes(name)) {
        const dotIndex = base.lastIndexOf(".");
        const baseName = dotIndex !== -1 ? base.substring(0, dotIndex) : base;
        const ext = dotIndex !== -1 ? base.substring(dotIndex) : "";
        name = `${baseName}-${counter}${ext}`;
        counter++;
      }

      this.dataFileAll.push(name);
      const newFile = new File([file], name, { type: file.type });
      return newFile;
    },
    // --- ฟังก์ชัน preview notice ---
    async previewMultiFile(event) {
      const input = event.target;
      if (!input.files || !input.files.length) return;

      const files = Array.from(input.files);
      for (let rawFile of files) {
        const file = this.getUniqueFileName(rawFile);

        const result = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => resolve(e.target.result);
          reader.onerror = (err) => reject(err);
          reader.readAsDataURL(file);
        });

        this.getpreview_listnotice.push(result);
        this.preview_listnotice.push(result);

        // ✅ รองรับ pdf, image, และ word
        if (
          file.type === "application/pdf" ||
          file.type.split("/")[0] === "image" ||
          file.type === "application/msword" ||
          file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        ) {
          this.image_listnotice.push(file);
          this.filenamenotice.push(file.name);
        }
      }

      this.preview_listnotice2 = this.preview_listnotice;
      this.checkfilenotice = true;
      input.value = "";
    },
    previewImage(event) {
      const files = event.target.files;
      if (!files.length) return;

      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        if (!file.type.startsWith("image/")) {
          alert("กรุณาเลือกไฟล์รูปภาพเท่านั้น");
          continue;
        }

        // ✅ ใช้ getUniqueFileName(file) แทน
        const uniqueFile = this.getUniqueFileName(file);

        // เก็บไฟล์ (เก็บไฟล์ใหม่ที่ชื่อ unique แล้ว)
        this.images.push(uniqueFile);
        this.imagenames.push(uniqueFile.name);

        // อ่านไฟล์แล้ว resize
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            const maxSize = 592;
            let width = img.width;
            let height = img.height;

            // คำนวณอัตราส่วน
            if (width > height) {
              if (width > maxSize) {
                height = Math.round((height * maxSize) / width);
                width = maxSize;
              }
            } else {
              if (height > maxSize) {
                width = Math.round((width * maxSize) / height);
                height = maxSize;
              }
            }

            canvas.width = width;
            canvas.height = height;

            ctx.drawImage(img, 0, 0, width, height);

            const resizedDataUrl = canvas.toDataURL("image/jpeg", 0.9);
            this.previews.push(resizedDataUrl);
          };
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      }

      this.checkimageadd = true;

      // รีเซต input เพื่อให้เลือกไฟล์ชื่อเดิมอีกครั้งได้
      event.target.value = null;
    },
    previewImageOpposed(event) {
      const files = event.target.files;
      if (!files.length) return;

      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        if (!file.type.startsWith("image/")) {
          alert("กรุณาเลือกไฟล์รูปภาพเท่านั้น");
          continue;
        }

        // ✅ ใช้ getUniqueFileName(file) แทน
        const uniqueFile = this.getUniqueFileName(file);

        // เก็บไฟล์ Opposed
        this.imagesOpposed.push(uniqueFile);
        this.imagenamesOpposed.push(uniqueFile.name);

        // อ่านไฟล์แล้ว resize
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            const maxSize = 592;
            let width = img.width;
            let height = img.height;

            // คำนวณอัตราส่วน
            if (width > height) {
              if (width > maxSize) {
                height = Math.round((height * maxSize) / width);
                width = maxSize;
              }
            } else {
              if (height > maxSize) {
                width = Math.round((width * maxSize) / height);
                height = maxSize;
              }
            }

            canvas.width = width;
            canvas.height = height;

            ctx.drawImage(img, 0, 0, width, height);

            const resizedDataUrl = canvas.toDataURL("image/jpeg", 0.9);
            this.previewsOpposed.push(resizedDataUrl);
          };
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      }

      this.checkimageaddOpposed = true;

      // รีเซต input เพื่อให้เลือกไฟล์ชื่อเดิมอีกครั้งได้
      event.target.value = null;
    },

    async previewMultiAttachFile(event) {
      const input = event.target;
      if (!input.files || !input.files.length) return;

      const files = Array.from(input.files);
      for (let rawFile of files) {
        const file = this.getUniqueFileName(rawFile);

        const result = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => resolve(e.target.result);
          reader.onerror = (err) => reject(err);
          reader.readAsDataURL(file);
        });

        this.getpreview_listattach.push(result);
        this.preview_listattach.push(result);

        // ✅ รองรับ PDF, Image และ Word
        if (
          file.type === "application/pdf" ||
          file.type.split("/")[0] === "image" ||
          file.type === "application/msword" ||
          file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        ) {
          this.image_listattach.push(file);
          this.filenameattach.push(file.name);
        }
      }

      this.preview_listattach2 = this.preview_listattach;
      this.checkfileattach = true;
      input.value = "";
    },
    async previewMultiImage(event) {
      const input = event.target;
      if (!input.files || !input.files.length) return;

      const files = Array.from(input.files);
      for (let rawFile of files) {
        // ✅ รับเฉพาะไฟล์ PDF เท่านั้น
        if (rawFile.type !== "application/pdf") continue;

        // ✅ สร้างชื่อไฟล์ไม่ซ้ำ
        const file = this.getUniqueFileName(rawFile);

        // ✅ อ่านไฟล์เป็น Base64
        const result = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => resolve(e.target.result);
          reader.onerror = (err) => reject(err);
          reader.readAsDataURL(file);
        });

        // ✅ push preview
        this.getpreview_list.push(result);
        this.preview_list.push(result);

        // ✅ push file และชื่อไฟล์
        this.image_list.push(file);
        this.filename.push(file.name);
      }

      // ✅ อัปเดตตัวแปร preview อื่น ๆ
      this.preview_list2 = this.preview_list;
      this.checkfileeadd = true;

      // ✅ reset input
      input.value = "";
    },
    async previewMultiImage_cer(event) {
      const input = event.target;
      if (!input.files || !input.files.length) return;

      const files = Array.from(input.files);
      for (let rawFile of files) {
        // ✅ รับเฉพาะไฟล์ PDF เท่านั้น
        if (rawFile.type !== "application/pdf") continue;

        // ✅ สร้างชื่อไฟล์ไม่ซ้ำ
        const file = this.getUniqueFileName(rawFile);

        // ✅ อ่านไฟล์เป็น Base64 สำหรับ preview
        const result = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => resolve(e.target.result);
          reader.onerror = (err) => reject(err);
          reader.readAsDataURL(file);
        });

        // ✅ เก็บ preview
        this.getpreview_list_cer.push(result);
        this.preview_list_cer.push(result);

        // ✅ เก็บไฟล์และชื่อไฟล์
        this.image_list_cer.push(file);
        this.filename_cer.push(file.name);
      }

      // ✅ อัปเดตรายการ preview สำรอง
      this.preview_list2_cer = this.preview_list_cer;
      this.checkfileeadd_cer = true;

      // ✅ reset input
      input.value = "";
    },
    async previewMultiReceipt(event) {
      const input = event.target;
      if (!input.files || !input.files.length) return;

      const files = Array.from(input.files);
      for (let rawFile of files) {
        const file = this.getUniqueFileName(rawFile);

        const result = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => resolve(e.target.result);
          reader.onerror = (err) => reject(err);
          reader.readAsDataURL(file);
        });

        this.getpreview_listreceipt.push(result);
        this.preview_listrecicpt.push(result);

        if (
          file.type === "application/pdf" ||
          file.type.split("/")[0] === "image"
        ) {
          this.image_listrecicpt.push(file);
          this.filenamerecive.push(file.name);
        }
      }

      this.preview_listrecipt2 = this.preview_listrecicpt;
      this.checkfileattach = true;
      input.value = "";
    },
    async previewreceiptfile(index) {
      if (this.image_listrecicpt[index].isOld) {
        if (this.image_listrecicpt[index].type == "file") {
          let fileUrl = `${filemasterTMUrl}/${this.$route.params.mastertm_id}/${this.image_listrecicpt[index].name}`;
          const newTab = window.open("");
          newTab.document.write(`
            <html>
              <head>
                <title>PDF Preview</title>
                <style>
                  html, body { margin:0; height:100%; overflow:hidden; }
                  iframe { border:none; width:100%; height:100%; }
                </style>
              </head>
              <body>
                <iframe src="${fileUrl}" title="PDF Preview"></iframe>
              </body>
            </html>
          `);
          newTab.document.close();
        } else {
          let fileUrl = `${imagemasterTMUrl}/${this.$route.params.mastertm_id}/${this.image_listrecicpt[index].name}`;
          const newTab = window.open("");
          newTab.document.write(`
            <html>
              <head>
                <title>Image Preview</title>
                <style>
                  html, body {
                    margin:0;
                    height:100%;
                    overflow:hidden;
                    background-color:black;
                    display:flex;
                    justify-content:center;
                    align-items:center;
                  }
                  img { max-width:100%; max-height:100%; object-fit:contain; }
                </style>
              </head>
              <body>
                <img src="${fileUrl}" alt="Image Preview" />
              </body>
            </html>
          `);
          newTab.document.close();
        }
      } else {
        var checkfile = this.image_listrecicpt[index];
        if (checkfile.type == `application/pdf`) {
          const reader = new FileReader();
          reader.onload = (e) => {
            const checkfile = e.target.result;
            let pdf_newTab = window.open("");
            pdf_newTab.document.write(`
            <html>
              <head>
                <title>PDF Preview</title>
                <style>
                  html, body {
                    margin: 0;
                    height: 100%;
                    overflow: hidden;
                  }
                  iframe {
                    border: none;
                    width: 100%;
                    height: 100%;
                  }
                </style>
              </head>
              <body>
                <iframe src="${checkfile}" title="PDF Preview"></iframe>
              </body>
            </html>
          `);
            pdf_newTab.document.close();
          };
          reader.readAsDataURL(checkfile);
        } else {
          const reader = new FileReader();
          reader.onload = (e) => {
            const checkfile = e.target.result; // Base64 image data
            let image_newTab = window.open(""); // เปิดแท็บใหม่
            image_newTab.document.write(`
            <html>
              <head>
                <title>Image Preview</title>
                <style>
                  html, body {
                    margin: 50px 0 0 0;
                    height: 80%;
                    overflow: hidden;
                    background-color: black;
                    display: flex;
                    justify-content: center; /* จัดกลางในแนวนอน */
                    align-items: center; /* จัดกลางในแนวตั้ง */
                  }
                  img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain; /* รูปภาพจะไม่ยืดออก */
                  }
                </style>
              </head>
              <body>
                <img src="${checkfile}" title="Image Preview" />
              </body>
            </html>
          `);
            image_newTab.document.close();
          };
          reader.readAsDataURL(checkfile);
        }
      }
    },

    async confirmdeleteattreceipt(index) {
      this.indexdeleteattreciept = index;
      this.dialogconfirmdeleteattrecipt = true;
    },
    async closepreviewreceipt(index) {
      this.indexdeleteattreciept = -1;
      this.dialogconfirmdeleteattrecipt = false;
    },
    async deletedialogconfirmdeletereceipt() {
      if (this.image_listrecicpt[this.indexdeleteattreciept].isOld) {
        this.removeReciveFile.push({
          id: this.image_listrecicpt[this.indexdeleteattreciept].id,
          name: this.image_listrecicpt[this.indexdeleteattreciept].name,
          type: this.image_listrecicpt[this.indexdeleteattreciept].type,
          appoinmentId: Number(this.$route.params.appointment_id),
        });
      }
      this.filenamerecive.splice(this.indexdeleteattreciept, 1);
      this.image_listrecicpt.splice(this.indexdeleteattreciept, 1);
      this.dialogconfirmdeleteattrecipt = false;
    },
    async uploadCSVFile(event) {
      const input = event.target;
      if (!input.files || !input.files.length) return;

      const files = Array.from(input.files);
      const newFiles = [];

      for (let rawFile of files) {
        if (!rawFile.name.toLowerCase().endsWith(".csv")) continue;

        const file = this.getUniqueFileName
          ? this.getUniqueFileName(rawFile)
          : rawFile;
        newFiles.push(file);
      }

      // แทนที่ไฟล์เก่าด้วยไฟล์ใหม่ทั้งหมด
      this.fileList_good_service = newFiles;

      // reset input เพื่อให้เลือกไฟล์ซ้ำได้
      input.value = "";
    },
    removeFileGood(type, index) {
      let list;
      if (type === "good_service") list = this.fileList_good_service;
      list.splice(index, 1);
    },
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },
};
